/* ==========================================================================
   FX-WELT — flexisolar.de
   Zusatzschicht ueber dem Bestands-Theme. Rueckbau = Datei loeschen.
   Kein Bestandsskript wird veraendert oder ueberschrieben.
   ========================================================================== */

/* ==========================================================================
   ABSCHNITT 1 — HEADER  (sections/fx-header.liquid)            B E G I N N

   Regeln, die hier bindend sind (RUECKBAU.md):
   1. Nie querySelector auf die Scope-Wurzel. Gesucht wird dokumentweit,
      eingegrenzt ueber das Praefix '[data-fx-scope] ' und danach auf die
      jeweilige Instanz gefiltert. Mehrere Instanzen laufen alle.
   2. Idempotent: der Theme-Editor laedt Sections nach. Jedes gebundene
      Element bekommt ein Marker-Attribut, init() haengt zusaetzlich an
      'shopify:section:load'.
   3. Keine requestAnimationFrame-Dauerschleife. Das Laufband ist ein
      CSS-Keyframe und haengt an einem IntersectionObserver. Scroll laeuft
      passiv und wird pro Ausbruch einmal per rAF gebuendelt.
   4. Genau EIN Zustand je Dokument. Das Asset wird von jeder Section, die es
      einbindet, erneut ausgefuehrt, und der Theme-Editor laedt es nach. Ohne
      Singleton haette jede Ausfuehrung ihr eigenes heads-Register und ihre
      eigenen globalen Listener: doppelte Scroll-, Escape-, Click- und
      Shopify-Handler, und ein toter spaeterer Zustand wuerde die Klassen
      eines offenen Kopfes beim naechsten Scroll wieder ueberschreiben.
      Deshalb haengen Bootstrap, Zustandsregister und globale Listener an
      window.fxWeltHeader; jede weitere Ausfuehrung ruft nur noch dessen
      init() auf.

   DOM je Instanz:
     .fx-header-section        <- Shopify-Wrapper, traegt section-header
       [data-fx-scope]         <- Suchbereich dieses Skripts
         [data-fx-header]      <- Kopf mit Leiste, Suche, Panels
                                  (<sticky-header> / <static-header>)
         [data-fx-drawer]      <- Schubfach
         [data-fx-probe]       <- Messfuehler fuer den transparenten Zustand
   ========================================================================== */
(function () {
  'use strict';

  var NS = 'fxWeltHeader';

  /* Zweite und jede weitere Ausfuehrung des Assets: nur anstossen. */
  if (window[NS] && typeof window[NS].init === 'function') {
    window[NS].init();
    return;
  }

  var SCOPE = '[data-fx-scope] ';
  var SOLID_AT = 40;
  var DESKTOP = '(hover: hover) and (min-width: 1180px)';
  /* Dieselbe Schwelle wie in fx-welt.css: darunter gilt das Schubfach ohnehin. */
  var NAV_BP = '(min-width: 1180px)';
  var NAV_SLACK = 1;
  /* Abstand zwischen Hin- und Rueckschaltschwelle. Muss kleiner sein als die
     Breite des Menue-Knopfes, sonst entsteht wieder eine tote Zone. */
  var NAV_HYST = 24;
  var FIT_DELAY = 120;
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select, textarea, summary, [tabindex]:not([tabindex="-1"])';

  function noop() {}

  /* Dokumentweit suchen, auf die Instanz eingegrenzt. Ohne `scope` sind es
     alle Instanzen im Dokument — nie das ganze Dokument. */
  function fxAll(sel, scope) {
    var list = document.querySelectorAll(SCOPE + sel);
    var out = [];
    for (var i = 0; i < list.length; i++) {
      if (!scope || scope.contains(list[i])) out.push(list[i]);
    }
    return out;
  }

  function fxOne(sel, scope) {
    return fxAll(sel, scope)[0] || null;
  }

  /* ------------------------------------------------------------------
     Zustand je Instanz — ein Register fuer das ganze Dokument
     ------------------------------------------------------------------ */
  var heads = [];

  function head(scope) {
    for (var i = 0; i < heads.length; i++) {
      if (heads[i].scope === scope) return heads[i];
    }
    var h = {
      scope: scope,
      wrap: scope.closest('.fx-header-section') || scope,
      root: null,
      openKey: null,
      searchOpen: false,
      drawerOpen: false,
      lastFocus: null,
      stickyType: 'none',
      stickyAlways: false,
      stickyClaimed: false,
      boundsTop: 0,
      boundsBottom: 0,
      lastTop: 0,
      navNeed: 0,
      navCompact: false,
      fitTimer: 0
    };
    heads.push(h);
    return h;
  }

  function forget(scope) {
    for (var i = heads.length - 1; i >= 0; i--) {
      if (heads[i].scope === scope) {
        if (heads[i].fitTimer) clearTimeout(heads[i].fitTimer);
        heads.splice(i, 1);
      }
    }
  }

  /* ------------------------------------------------------------------
     Fester oder durchsichtiger Zustand
     `scrolled-past-header` ist der Schalter des Bestands: solange er auf dem
     Shopify-Wrapper fehlt, macht die Hero-Regel den Kopf durchsichtig. Wir
     setzen ihn zusaetzlich, sobald ein Panel offen ist.
     ------------------------------------------------------------------ */
  function applyState(h) {
    var scrolled = (window.pageYOffset || document.documentElement.scrollTop || 0) > SOLID_AT;
    var open = !!h.openKey || h.searchOpen || h.drawerOpen;
    var solid = scrolled || open;

    h.wrap.classList.toggle('fx-is-scrolled', scrolled);
    h.wrap.classList.toggle('fx-is-open', open);
    h.wrap.classList.toggle('fx-is-solid', solid);
    h.wrap.classList.toggle('scrolled-past-header', solid);
  }

  /* Messfuehler ablesen: durchsichtig = auf dieser Seite liegt ein Hero mit
     transparentem Kopf. Der Fuehler haengt in einem eigenen
     .section-header-Container und ist deshalb vom Scroll-Zustand unabhaengig. */
  function detectOverlay(h) {
    var probe = fxOne('[data-fx-probe]', h.scope);
    if (!probe) return;
    var bg = (window.getComputedStyle(probe).backgroundColor || '').replace(/\s+/g, '');
    var transparent = bg === 'transparent' || /,0(\.0+)?\)$/.test(bg);
    if (transparent) h.wrap.setAttribute('data-fx-overlay', '');
    else h.wrap.removeAttribute('data-fx-overlay');
  }

  /* Ein fremder Bestands-Kopf auf derselben Seite. Unsere eigene Wurzel ist
     seit dem Sticky-Rueckbau selbst ein <sticky-header>, zaehlt hier also
     ausdruecklich nicht mit. */
  function foreignHeader() {
    var list = document.querySelectorAll('sticky-header, static-header');
    for (var i = 0; i < list.length; i++) {
      if (!list[i].closest('[data-fx-scope]')) return true;
    }
    return false;
  }

  /* Hoehe melden. Nur wenn der Bestands-Kopf nicht auch auf der Seite ist,
     sonst streiten sich zwei Koepfe um dieselbe Variable. */
  function reportHeight(h) {
    if (foreignHeader()) return;
    var px = h.wrap.offsetHeight;
    if (px > 0) document.documentElement.style.setProperty('--header-height', px + 'px');
  }

  /* ------------------------------------------------------------------
     Sticky — Verhalten des Bestands
     Die Kopf-Wurzel wird als <sticky-header data-sticky-type="…"> bzw. als
     <static-header> gerendert, genau wie in sections/header.liquid. Ist die
     Bestands-Klasse StickyHeader definiert, macht sie die Arbeit und wir
     fassen nichts an. Ist sie es nicht (Section-JS des Bestands-Headers nicht
     auf der Seite), springt dieser Ersatz ein: gleiche Klassen, gleiche
     Schwellen, gleiche Reihenfolge wie im Bestand.
     ------------------------------------------------------------------ */
  function nativeSticky() {
    return !!(window.customElements && window.customElements.get('sticky-header'));
  }

  function stickyMeasure(h) {
    if (!h.root || h.stickyType === 'none') return;
    if (h.wrap.classList.contains('shopify-section-header-sticky')) return;
    var rect = h.wrap.getBoundingClientRect();
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    h.boundsTop = rect.top + y;
    h.boundsBottom = h.boundsTop + rect.height;
  }

  function stickyHide(h) {
    if (h.stickyAlways) return;
    if (h.openKey || h.searchOpen || h.drawerOpen) return;
    h.wrap.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  function stickyReveal(h) {
    if (h.stickyAlways) return;
    h.wrap.classList.add('shopify-section-header-sticky', 'animate');
    h.wrap.classList.remove('shopify-section-header-hidden');
  }

  function stickyReset(h) {
    if (h.stickyAlways) return;
    h.wrap.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  /* Der Bestand ruft am <sticky-header> reveal() auf (cart-notification.js).
     Solange wir den Ersatz fahren, muss die Wurzel diese Methoden haben. */
  function stickyClaim(h) {
    if (h.stickyClaimed || !h.root) return;
    h.stickyClaimed = true;
    h.root.reveal = function () {
      stickyReveal(h);
    };
    h.root.hide = function () {
      stickyHide(h);
    };
    h.root.reset = function () {
      stickyReset(h);
    };
  }

  function stickyRelease(h) {
    if (!h.stickyClaimed || !h.root) return;
    h.stickyClaimed = false;
    delete h.root.reveal;
    delete h.root.hide;
    delete h.root.reset;
  }

  function stickyScroll(h) {
    if (!h.root || h.stickyType === 'none') return;
    if (nativeSticky()) {
      stickyRelease(h);
      return;
    }
    stickyClaim(h);

    var top = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (h.stickyAlways) {
      h.wrap.classList.add('shopify-section-header-sticky');
      h.lastTop = top;
      return;
    }

    if (top > h.lastTop && top > h.boundsBottom) stickyHide(h);
    else if (top < h.lastTop && top > h.boundsBottom) stickyReveal(h);
    else if (top <= h.boundsTop) stickyReset(h);

    h.lastTop = top;
  }

  /* ------------------------------------------------------------------
     Panels
     ------------------------------------------------------------------ */
  function closePanel(h) {
    if (!h.openKey) return;
    fxAll('.fx-nav__toggle', h.scope).forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
      var li = t.closest('.fx-nav__item');
      if (li) li.classList.remove('fx-nav__item--active');
    });
    fxAll('.fx-panel', h.scope).forEach(function (p) {
      p.hidden = true;
    });
    h.openKey = null;
    applyState(h);
  }

  function openPanel(h, key) {
    if (h.openKey === key) return;
    closeSearch(h);
    h.openKey = key;
    fxAll('.fx-nav__toggle', h.scope).forEach(function (t) {
      var on = t.getAttribute('data-fx-toggle') === key;
      t.setAttribute('aria-expanded', on ? 'true' : 'false');
      var li = t.closest('.fx-nav__item');
      if (li) li.classList.toggle('fx-nav__item--active', on);
    });
    fxAll('.fx-panel', h.scope).forEach(function (p) {
      p.hidden = p.getAttribute('data-fx-panel') !== key;
    });
    applyState(h);
  }

  function togglePanel(h, key) {
    if (h.openKey === key) closePanel(h);
    else openPanel(h, key);
  }

  function focusToggle(h, key) {
    var back = fxAll('.fx-nav__toggle', h.scope).filter(function (t) {
      return t.getAttribute('data-fx-toggle') === key;
    })[0];
    if (back) back.focus();
  }

  /* ------------------------------------------------------------------
     Sicherheitsnetz gegen die ueberlaufende Menueleiste

     Die Aufteilung der Leiste stimmt (Marke und Aktionsgruppe auf
     `flex: none`, Navigation `flex: 1 1 auto; min-width: 0`). Genau deshalb
     kann die Liste aber laenger werden als ihr Kasten: sie ist nowrap und
     laeuft dann sichtbar heraus, quer ueber Suchfeld, Aktionsknopf und
     Warenkorb. Abschneiden verbietet sich — die Punkte waeren lautlos weg.
     Also gemessen und im Zweifel auf das Schubfach umgestellt.

     Zwei Feinheiten:
     * Der Platz wird GERECHNET, nicht an .fx-nav gemessen. Im Schubfach-
       Zustand ist .fx-nav display:none und hat gar keine Breite mehr.
     * Der Bedarf wird nur gemerkt, solange die Liste im Fluss steht. Im
       Schubfach-Zustand bleibt der zuletzt gemessene Wert stehen, bis wieder
       Platz da ist. Weil die Aktionsgruppe im Schubfach-Zustand um den
       Menue-Knopf waechst, liegt die Rueckschaltschwelle hoeher als die
       Hinschaltschwelle — die Umschaltung kann nicht flattern.
     ------------------------------------------------------------------ */
  function widthOf(el) {
    return el ? el.getBoundingClientRect().width : 0;
  }

  /* Platz, der der Navigation zusteht: Innenbreite der Leiste ohne Marke,
     ohne Aktionsgruppe und ohne die Luecken dazwischen. */
  function navRoom(h) {
    var bar = fxOne('.fx-bar__inner', h.scope);
    if (!bar) return 0;
    var cs = window.getComputedStyle(bar);
    var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
    var room = bar.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    var gaps = 0;
    var logo = fxOne('.fx-logo', h.scope);
    var tools = fxOne('.fx-tools', h.scope);
    if (logo) {
      room -= widthOf(logo);
      gaps++;
    }
    if (tools) {
      room -= widthOf(tools);
      gaps++;
    }
    return room - gap * gaps;
  }

  /* Breite, die die Menuepunkte nebeneinander brauchen.

     Bewusst NICHT list.scrollWidth: die Mega-Panels sind Kinder der <li> und
     stehen auf position:absolute mit voller Headerbreite. scrollWidth zaehlt
     absolut positionierte Nachfahren mit, sobald sie ueberstehen — gemessen
     wuerde also das Panel (rund 1440px) statt der Punkte (rund 800px), und
     die Navigation waere bei jeder Breite „zu breit" und dauerhaft im
     Schubfach. Genau das ist am 11.08. passiert.
     Die <li> selbst sind unbelastet: ein absolut positioniertes Kind traegt
     nichts zur Groesse seines Elternteils bei. Also Punkte summieren. */
  function navNeedOf(h) {
    var list = fxOne('.fx-nav__list', h.scope);
    if (!list) return 0;
    var items = fxAll('.fx-nav__list > .fx-nav__item', h.scope);
    if (!items.length) return 0;
    var cs = window.getComputedStyle(list);
    var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
    var sum = 0;
    for (var i = 0; i < items.length; i++) sum += items[i].getBoundingClientRect().width;
    if (!sum) return 0;
    return Math.ceil(sum + gap * (items.length - 1));
  }

  function setCompact(h, on) {
    if (h.navCompact === on) return;
    h.navCompact = on;
    h.wrap.classList.toggle('fx-is-compact', on);
  }

  function syncNavFit(h) {
    var nav = fxOne('.fx-nav', h.scope);
    var list = fxOne('.fx-nav__list', h.scope);
    if (!nav || !list) return;

    /* Unterhalb der Schwelle entscheidet die Medienabfrage, nicht wir. */
    if (!window.matchMedia(NAV_BP).matches) {
      setCompact(h, false);
      return;
    }

    /* Steht die Liste im Fluss, ist ihr Bedarf messbar. Im Schubfach-Zustand
       ist .fx-nav display:none, die Punkte haben dann keine Breite mehr —
       deshalb bleibt der zuletzt gemessene Wert stehen. */
    if (!h.navCompact) {
      var gemessen = navNeedOf(h);
      if (gemessen) h.navNeed = gemessen;
    }
    if (!h.navNeed) return;

    /* Hin- und Rueckweg messen NICHT denselben Platz: im Schubfach-Zustand
       traegt die Aktionsgruppe zusaetzlich den Menue-Knopf und ist rund 52px
       breiter. Wer den Rueckweg gegen diesen verengten Platz prueft, baut
       eine tote Zone — am 11.08. bei 1440px: ohne Knopf waeren 632px frei
       und die 589px der Punkte passten laengst, mit Knopf sind es 573px, und
       die Navigation kam nie zurueck.
       Also wird auf dem Rueckweg der Platz gerechnet, den es OHNE den Knopf
       gaebe. Damit es trotzdem nicht flattert, bleibt ein schmales Band:
       HYST ist kleiner als die Knopfbreite, die Schwellen liegen also noch
       auseinander, aber nur um ein paar Pixel statt um eine ganze Zone. */
    var platz = navRoom(h);
    if (h.navCompact) {
      var knopf = fxOne('.fx-icon-btn--burger', h.scope);
      if (knopf && knopf.offsetParent !== null) {
        var bar = fxOne('.fx-bar__inner', h.scope);
        var luecke = 0;
        if (bar) {
          var bcs = window.getComputedStyle(bar);
          luecke = parseFloat(bcs.columnGap) || parseFloat(bcs.gap) || 0;
        }
        platz += widthOf(knopf) + luecke - NAV_HYST;
      }
    }

    var eng = h.navNeed > platz + NAV_SLACK;
    if (eng === h.navCompact) return;

    setCompact(h, eng);
    /* Ein offenes Panel haengt an der Navigation, die es gerade nicht mehr gibt. */
    if (eng) closePanel(h);
    else h.navNeed = navNeedOf(h) || h.navNeed;
  }

  /* Entprellt. Keine rAF-Dauerschleife — der Anstoss kommt vom
     ResizeObserver, das Urteil faellt einen Timer spaeter und damit
     ausserhalb der Beobachter-Rueckmeldung. */
  function scheduleFit(h) {
    if (h.fitTimer) clearTimeout(h.fitTimer);
    h.fitTimer = setTimeout(function () {
      h.fitTimer = 0;
      syncNavFit(h);
    }, FIT_DELAY);
  }

  /* ------------------------------------------------------------------
     Ausklappbare Suche
     ------------------------------------------------------------------ */
  function closeSearch(h) {
    if (!h.searchOpen) return;
    h.searchOpen = false;
    fxAll('[data-fx-searchbar]', h.scope).forEach(function (b) {
      b.hidden = true;
    });
    fxAll('[data-fx-search-toggle]', h.scope).forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
    applyState(h);
  }

  function openSearch(h) {
    closePanel(h);
    h.searchOpen = true;
    fxAll('[data-fx-searchbar]', h.scope).forEach(function (b) {
      b.hidden = false;
    });
    fxAll('[data-fx-search-toggle]', h.scope).forEach(function (t) {
      t.setAttribute('aria-expanded', 'true');
    });
    applyState(h);
    var input = fxOne('[data-fx-searchbar-input]', h.scope);
    if (input) input.focus();
  }

  /* ------------------------------------------------------------------
     Schubfach
     Die Seitensperre haengt NICHT am einzelnen Schubfach, sondern an der
     Zahl aller offenen Schubfaecher im Dokument. Sonst gibt das Schliessen
     einer Instanz die Seite frei, waehrend eine zweite noch offen ist.
     ------------------------------------------------------------------ */
  function openDrawers() {
    return fxAll('[data-fx-drawer]:not([hidden])');
  }

  function syncScrollLock() {
    document.documentElement.classList.toggle('fx-no-scroll', openDrawers().length > 0);
  }

  function openDrawer(h, opener) {
    var d = fxOne('[data-fx-drawer]', h.scope);
    if (!d) return;
    closePanel(h);
    closeSearch(h);
    h.drawerOpen = true;
    h.lastFocus = opener || document.activeElement;
    d.hidden = false;
    syncScrollLock();
    fxAll('[data-fx-drawer-open]', h.scope).forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
    applyState(h);
    var closer = fxOne('[data-fx-drawer-close]:not([tabindex])', h.scope);
    if (closer) closer.focus();
  }

  function closeDrawer(h) {
    var d = fxOne('[data-fx-drawer]', h.scope);
    if (!d || !h.drawerOpen) return;
    h.drawerOpen = false;
    d.hidden = true;
    syncScrollLock();
    fxAll('[data-fx-drawer-open]', h.scope).forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    if (h.lastFocus && document.contains(h.lastFocus)) h.lastFocus.focus();
    h.lastFocus = null;
    applyState(h);
  }

  function trapFocus(h, event) {
    if (!h.drawerOpen || event.key !== 'Tab') return;
    var panel = fxOne('.fx-drawer__panel', h.scope);
    if (!panel) return;
    var items = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ------------------------------------------------------------------
     Laufband der Vorteilsleiste: CSS-Keyframe, angehalten ausserhalb des
     Sichtfelds. Keine Schleife in JS.
     ------------------------------------------------------------------ */
  var uspObserver = null;

  function observeUsp(el) {
    if (!('IntersectionObserver' in window)) {
      el.setAttribute('data-fx-usp-visible', '');
      el.classList.add('fx-usp--run');
      return;
    }
    if (!uspObserver) {
      uspObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.setAttribute('data-fx-usp-visible', '');
          else entry.target.removeAttribute('data-fx-usp-visible');
          entry.target.classList.toggle('fx-usp--run', entry.isIntersecting && !document.hidden);
        });
      });
    }
    uspObserver.observe(el);
  }

  /* Der Kopf klebt oben, das Laufband bleibt also meist im Sichtfeld. Im
     verborgenen Tab wird es trotzdem angehalten. */
  function syncUsp() {
    var list = fxAll('[data-fx-usp]');
    for (var i = 0; i < list.length; i++) {
      list[i].classList.toggle('fx-usp--run', list[i].hasAttribute('data-fx-usp-visible') && !document.hidden);
    }
  }

  /* ------------------------------------------------------------------
     Bindung — jedes Element genau einmal
     ------------------------------------------------------------------ */
  function once(el, fn) {
    if (!el || el.hasAttribute('data-fx-bound')) return false;
    el.setAttribute('data-fx-bound', '');
    fn(el);
    return true;
  }

  function bind(scope) {
    var h = head(scope);
    h.wrap = scope.closest('.fx-header-section') || scope;
    h.root = fxOne('[data-fx-header]', scope);
    h.stickyType = (h.root && h.root.getAttribute('data-sticky-type')) || 'none';
    h.stickyAlways = h.stickyType === 'always' || h.stickyType === 'reduce-logo-size';

    /* Uebernimmt die Bestands-Klasse StickyHeader unsere Wurzel, ruft deren
       hide() ein closeSearchModal(), das im Bestands-Kopf ein <details-modal>
       erwartet. Das gibt es hier nicht — ohne diese leere Eigenschaft am
       Element wirft jeder Weg-Scroll eine TypeError. Eigene Eigenschaft am
       Element, keine Aenderung an der Bestands-Klasse. */
    if (h.root) h.root.closeSearchModal = noop;

    fxAll('.fx-nav__toggle', scope).forEach(function (t) {
      once(t, function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          togglePanel(h, el.getAttribute('data-fx-toggle'));
        });
      });
    });

    fxAll('.fx-nav__item--menu', scope).forEach(function (li) {
      once(li, function (el) {
        el.addEventListener('mouseenter', function () {
          if (window.matchMedia(DESKTOP).matches) openPanel(h, el.getAttribute('data-fx-item'));
        });
      });
    });

    fxAll('[data-fx-header]', scope).forEach(function (root) {
      once(root, function (el) {
        el.addEventListener('mouseleave', function () {
          if (window.matchMedia('(hover: hover)').matches) closePanel(h);
        });
        el.addEventListener('focusout', function (e) {
          if (!h.openKey) return;
          if (e.relatedTarget && el.contains(e.relatedTarget)) return;
          closePanel(h);
        });
      });
    });

    fxAll('[data-fx-search-toggle]', scope).forEach(function (t) {
      once(t, function (el) {
        el.addEventListener('click', function () {
          if (h.searchOpen) closeSearch(h);
          else openSearch(h);
        });
      });
    });

    fxAll('[data-fx-search-close]', scope).forEach(function (t) {
      once(t, function (el) {
        el.addEventListener('click', function () {
          closeSearch(h);
          var opener = fxOne('[data-fx-search-toggle]', scope);
          if (opener) opener.focus();
        });
      });
    });

    fxAll('[data-fx-drawer-open]', scope).forEach(function (b) {
      once(b, function (el) {
        el.addEventListener('click', function () {
          openDrawer(h, el);
        });
      });
    });

    fxAll('[data-fx-drawer-close]', scope).forEach(function (b) {
      once(b, function (el) {
        el.addEventListener('click', function () {
          closeDrawer(h);
        });
      });
    });

    fxAll('[data-fx-drawer]', scope).forEach(function (d) {
      once(d, function (el) {
        el.addEventListener('keydown', function (e) {
          trapFocus(h, e);
        });
      });
    });

    fxAll('[data-fx-usp]', scope).forEach(function (u) {
      once(u, observeUsp);
    });

    if ('ResizeObserver' in window && !h.wrap.hasAttribute('data-fx-sized')) {
      h.wrap.setAttribute('data-fx-sized', '');
      var ro = new ResizeObserver(function () {
        reportHeight(h);
        stickyMeasure(h);
        scheduleFit(h);
      });
      ro.observe(h.wrap);
      /* Die Leiste zusaetzlich beobachten: ihre Innenbreite haengt an
         --page-width, nicht nur am Sichtfeld. Der Wrapper aendert dabei
         seine Groesse nicht, die Leiste schon. */
      var bar = fxOne('.fx-bar__inner', scope);
      if (bar) ro.observe(bar);
    }

    detectOverlay(h);
    reportHeight(h);
    stickyMeasure(h);
    /* Nach einem Nachladen im Theme-Editor kann ein anderes Menue haengen:
       Urteil und gemerkten Bedarf verwerfen und im Fluss neu messen. */
    setCompact(h, false);
    h.navNeed = 0;
    syncNavFit(h);
    applyState(h);
  }

  /* ------------------------------------------------------------------
     Globale Ereignisse — genau einmal je Dokument, im Singleton
     ------------------------------------------------------------------ */
  var globalsReady = false;

  function registerGlobals() {
    if (globalsReady) return;
    globalsReady = true;

    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          for (var i = 0; i < heads.length; i++) {
            applyState(heads[i]);
            stickyScroll(heads[i]);
          }
        });
      },
      { passive: true }
    );

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      heads.forEach(function (h) {
        if (h.drawerOpen) {
          closeDrawer(h);
        } else if (h.searchOpen) {
          closeSearch(h);
          var opener = fxOne('[data-fx-search-toggle]', h.scope);
          if (opener) opener.focus();
        } else if (h.openKey) {
          var key = h.openKey;
          closePanel(h);
          focusToggle(h, key);
        }
      });
    });

    document.addEventListener('click', function (e) {
      heads.forEach(function (h) {
        if (!h.openKey) return;
        if (h.scope.contains(e.target)) return;
        closePanel(h);
      });
    });

    document.addEventListener('visibilitychange', syncUsp);

    document.addEventListener('shopify:section:load', init);

    /* Nach dem Entladen einer Section: Register aufraeumen, Sperre neu
       ableiten und den Messfuehler noch einmal lesen. Faellt der
       transparente Hero weg, verschwindet data-fx-overlay erst dadurch.
       Ein Frame Abstand, damit das Stylesheet der Section weg ist. */
    document.addEventListener('shopify:section:unload', function (e) {
      for (var i = heads.length - 1; i >= 0; i--) {
        if (!document.contains(heads[i].scope)) heads.splice(i, 1);
      }
      if (e && e.target && e.target.querySelector) {
        var gone = e.target.querySelectorAll('[data-fx-scope]');
        for (var j = 0; j < gone.length; j++) forget(gone[j]);
      }
      syncScrollLock();
      window.requestAnimationFrame(function () {
        for (var k = 0; k < heads.length; k++) {
          detectOverlay(heads[k]);
          stickyMeasure(heads[k]);
        }
      });
    });
  }

  function init() {
    var scopes = document.querySelectorAll('[data-fx-scope]');
    for (var i = 0; i < scopes.length; i++) bind(scopes[i]);
    registerGlobals();
    syncScrollLock();
  }

  window[NS] = {
    init: init,
    instances: function () {
      return heads.slice();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ==========================================================================
   ABSCHNITT 1 — HEADER                                              E N D E
   ========================================================================== */

/* ==========================================================================
   ABSCHNITT 2 — KONFIGURATOR  (sections/fx-konfigurator.liquid)  B E G I N N

   Regeln, die hier bindend sind (RUECKBAU.md):
   1. Nie querySelector auf die Scope-Wurzel. Gesucht wird dokumentweit,
      eingegrenzt ueber '[data-fx-konfig] ' und danach auf die Instanz
      gefiltert. Mehrere Instanzen laufen alle.
   2. Idempotent: jede gebundene Wurzel bekommt ein Marker-Attribut, init()
      haengt zusaetzlich an 'shopify:section:load'. Das Asset wird von jeder
      Section erneut ausgefuehrt — Bootstrap, Zustandsregister und ALLE
      globalen Listener haengen deshalb an genau einem Singleton
      window.fxWeltKonfig; jede weitere Ausfuehrung ruft nur noch dessen
      init() auf. Ohne diesen Ausstieg entstuenden doppelte globale Listener
      und ein zweites, konkurrierendes Instanzregister.
   3. Keine requestAnimationFrame-Dauerschleife, kein filter:blur auf
      Bewegtem. Der Schrittwechsel ist ein CSS-Keyframe.

   DOM je Instanz:
     [data-fx-konfig]              <- Suchbereich dieses Abschnitts
       [data-fx-katalog]           <- JSON: Komponenten, Sets, Marken, Orte
       [data-fx-k-step]            <- Frage plus Antwortkarten
       [data-fx-k-result]          <- Abschluss-Screen, zwei Karten
       [data-fx-k-lader]           <- Ladeanzeige, erst ab 300 ms
       [data-fx-k-live]            <- Ansage fuer Screenreader

   FUENF SCHRITTE, Marke VOR Speicher (Beanstandung Prince 11.08., Punkt 3)
     0 Montageort · 1 Modulanzahl · 2 Marke · 3 Speichergroesse · 4 Ergebnis
   Die Marke steht vor der Speicherfrage, weil sie bestimmt, welche
   Kapazitaeten es ueberhaupt gibt: Anker 1,6 bis 5,4 kWh, Conow 2 bis 60 kWh,
   Jackery 2 bis 15 kWh, TSUN nur 2 kWh. Wer zuerst nach der Groesse fragt,
   fragt nach etwas, das es bei dieser Marke vielleicht gar nicht gibt.
   „Ist mir egal" zeigt die Vereinigungsmenge aller Kapazitaeten.

   BILDER STATT TEXT (Punkt 2)
     Jede Kachel traegt ein Bild aus dem Shop:
       Montageort   Situationsfoto der Ort-Kollektion, sonst Halterungsbild
       Modulanzahl  Produktbild des Moduls plus Anzahl als Marke oben rechts
       Marke        Logo aus dem Metaobject `marke`
       Speicher     Produktbild der guenstigsten Variante dieser Kapazitaet
     Faellt ein Bild aus (onerror) oder fehlt es, greift ein Platzhalter mit
     Kuerzel oder Symbol. Kein Loch, kein zerbrochenes Bild.

   MONTAGEORT-VOKABULAR
     balkon · flachdach · ziegeldach · boden · wand. `wand` heisst wand, nicht
     fassade: so steht es in konfig.montageort auf den Halterungs-Varianten.
     Fruehere Fassungen hiessen hier `fassade` und trafen damit keine einzige
     Halterung.

   Rechengrundlage der Ersparnis (KONFIGURATOR-SPEC: aus confi uebernehmen,
   nicht neu erfinden), Quelle live/confi.flexisolar.de/data/:
     * Strompreis 0,41 EUR/kWh ...... config.json pricing.electricityPrice_eur
     * Ertrag 950 kWh je kWp ........ federal-states.json, NW (Bundesmitte)
     * Eigenverbrauchsquoten ........ config.json consumption.selfConsumptionRates
                                      0,30 ohne Speicher; 0,60 bis 5 kWh;
                                      0,70 bis 10 kWh; 0,80 darueber
   Strompreis und Ertrag sind Section-Settings, die Quote steht fest.
   Die Faktoren je Montageort kennt die confi nicht (sie rechnet mit
   Ausrichtung und Neigung), sie stammen aus dem Prototyp v2 von Prince.
   Der Prototyp nennt an anderer Stelle deutlich hoehere Quoten (0,8 bis 0,95);
   die gelten NICHT, die confi ist die SSOT.
   Anders als die confi wird der Eigenverbrauch NICHT am Haushaltsverbrauch
   gedeckelt, den fragt der Konfigurator nicht ab.

   DataLayer: keine eigenen Pushes. Es laeuft das gemeinsame Modul
   assets/fx-konfigurator-tracking.js (Vorlage v2.0), Aufrufe siehe 2.9.
   ========================================================================== */
(function () {
  'use strict';

  var NS = 'fxWeltKonfig';

  /* Zweite und jede weitere Ausfuehrung des Assets: nur anstossen. */
  if (window[NS] && typeof window[NS].init === 'function') {
    window[NS].init();
    return;
  }

  var SCOPE = '[data-fx-konfig] ';

  /* Montageorte. label/sub sind Anzeige, f ist der Ertragsfaktor.
     Die Schluessel sind exakt das Vokabular aus konfig.montageort. */
  var ORTE = {
    balkon: { label: 'Balkon', sub: 'am Geländer, ohne Bohren', f: 0.72 },
    flachdach: { label: 'Flachdach', sub: 'Garage, Carport, Anbau', f: 0.95 },
    ziegeldach: { label: 'Ziegeldach', sub: 'Schrägdach mit Ziegeln', f: 1.0 },
    boden: { label: 'Garten oder Boden', sub: 'frei aufgeständert', f: 0.9 },
    wand: { label: 'Wand oder Fassade', sub: 'senkrecht montiert', f: 0.74 }
  };
  var ORT_REIHE = ['balkon', 'flachdach', 'ziegeldach', 'boden', 'wand'];

  /* Symbole nur noch als Rueckfall, wenn weder Kollektions- noch
     Produktbild vorhanden ist. */
  var ORT_ICON = {
    balkon: '<path d="M3 14h18M7 14v6M12 14v6M17 14v6"/><path d="M5 11l7-4 7 4"/>',
    wand: '<path d="M4 3v18"/><path d="M8 6h12v9H8z"/>',
    ziegeldach: '<path d="M3 12l9-7 9 7"/><path d="M8 12h9v6H8z"/>',
    flachdach: '<path d="M3 19h18"/><path d="M6 16l11-6"/><path d="M6 16v3M17 10v9"/>',
    boden: '<path d="M3 20h18"/><path d="M5 16l12-6"/><path d="M11 13v7"/>',
    ohne: '<circle cx="12" cy="12" r="8"/><path d="M7 17L17 7"/>',
    egal: '<circle cx="12" cy="12" r="9"/><path d="M9 10a3 3 0 115 2c-.8.6-2 1-2 2"/><path d="M12 17.5v.01"/>',
    keinSpeicher: '<path d="M4 8h13v8H4z"/><path d="M20 11v2"/><path d="M7 12h7"/>'
  };

  var ANZAHLEN = [2, 4, 6, 8];

  /* Hoechstens so viele Kapazitaets-Kacheln. Conow allein bringt zwanzig
     Varianten von 6 bis 60 kWh mit; die zeigt niemand als zwanzig Kacheln.
     Ausgewaehlt wird ueber die ganze Spanne verteilt, kleinste und groesste
     immer dabei. */
  var KWH_KACHELN = 6;

  var SCHRITT_LABEL = ['Montageort', 'Modulanzahl', 'Marke', 'Speicher', 'Ergebnis'];
  var SCHRITTE_GESAMT = 5;
  var LETZTER = SCHRITTE_GESAMT - 1;

  /* Eigenverbrauchsquote nach confi (Schwellen 5 und 10 kWh). */
  function quote(kwh) {
    if (!kwh) return 0.3;
    if (kwh <= 5) return 0.6;
    if (kwh <= 10) return 0.7;
    return 0.8;
  }

  /* ------------------------------------------------------------------
     2.6 Suchen und kleine Helfer
     ------------------------------------------------------------------ */
  function kAll(sel, scope) {
    var list = document.querySelectorAll(SCOPE + sel);
    var out = [];
    for (var i = 0; i < list.length; i++) {
      if (!scope || scope.contains(list[i])) out.push(list[i]);
    }
    return out;
  }

  function kOne(sel, scope) {
    return kAll(sel, scope)[0] || null;
  }

  function zahl(v) {
    if (v === null || v === undefined || v === '') return null;
    var n = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.'));
    return isFinite(n) ? n : null;
  }

  function eur(cent) {
    var n = (cent || 0) / 100;
    var nk = cent % 100 === 0 ? 0 : 2;
    return n.toLocaleString('de-DE', { minimumFractionDigits: nk, maximumFractionDigits: nk }) + ' €';
  }

  function kwhText(v) {
    return Number(v).toLocaleString('de-DE', { maximumFractionDigits: 2 }) + ' kWh';
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined && text !== null) e.textContent = String(text);
    return e;
  }

  /* ------------------------------------------------------------------
     2.7 Zustand je Instanz
     ------------------------------------------------------------------ */
  var instanzen = [];
  var aktiv = null;

  function instanz(root) {
    for (var i = 0; i < instanzen.length; i++) {
      if (instanzen[i].root === root) return instanzen[i];
    }
    var I = {
      root: root,
      kat: leseKatalog(root),
      schritt: 0,
      wahl: { ort: null, anzahl: null, marke: null, speicher: null },
      ergebnis: null,
      weg: 'einzelteile',
      anim: 0,
      strompreis: zahl(root.getAttribute('data-fx-strompreis')) || 0.41,
      ertrag: zahl(root.getAttribute('data-fx-ertrag')) || 950,
      zeigeErsparnis: root.getAttribute('data-fx-savings') !== '0',
      cartAdd: root.getAttribute('data-fx-cart-add') || '/cart/add',
      cartUrl: root.getAttribute('data-fx-cart-url') || '/cart',
      trackId: root.getAttribute('data-fx-track-id') || 'fx-balkonkraftwerk'
    };
    /* Sichtbarer Stand des Katalogs. Steht dort mehr als eine Seite, hat
       Liquid abgeschnitten und man sieht es im Inspektor, statt dass die
       Stueckliste still leer bleibt. */
    root.setAttribute('data-fx-stand', I.kat.n + ' Produkte, Seite 1 von ' + I.kat.seiten);
    instanzen.push(I);
    return I;
  }

  /* Katalog lesen. Doppelte Eintraege fallen raus. */
  function leseKatalog(root) {
    var kat = { komponenten: [], sets: [], marken: [], orte: {}, n: 0, seiten: 1 };
    var block = kOne('[data-fx-katalog]', root);
    if (!block) return kat;
    var roh;
    try {
      roh = JSON.parse(block.textContent || '{}');
    } catch (e) {
      return kat;
    }
    kat.komponenten = putzen(roh.komponenten);
    kat.sets = putzen(roh.sets);
    kat.marken = roh.marken || [];
    kat.n = roh.n || 0;
    kat.seiten = roh.seiten || 1;
    (roh.orte || []).forEach(function (o) {
      if (o && o.k) kat.orte[o.k] = o;
    });
    return kat;
  }

  function putzen(liste) {
    var out = [];
    var gesehen = {};
    if (!liste || !liste.length) return out;
    for (var i = 0; i < liste.length; i++) {
      var p = liste[i];
      if (!p || !p.id || gesehen[p.id]) continue;
      gesehen[p.id] = true;
      p.p = zahl(p.p) || 0;
      p.wp = zahl(p.wp);
      p.mw = zahl(p.mw);
      p.mm = zahl(p.mm);
      p.mod = zahl(p.mod);
      p.mwp = zahl(p.mwp);
      p.kwh = zahl(p.kwh);
      p.v = p.v || '';
      /* montageort ist eine Liste. Steht irgendwo doch ein einzelner Text,
         wird daraus eine Liste mit einem Eintrag — sonst suchte indexOf im
         String und traefe „wand" auch in „Wandhalterung ohne Neigung". */
      if (typeof p.o === 'string') p.o = p.o ? [p.o] : [];
      p.o = p.o && p.o.length ? p.o : [];
      p.halt = p.halt || {};
      out.push(p);
    }
    return out;
  }

  function rolle(I, name) {
    var out = [];
    for (var i = 0; i < I.kat.komponenten.length; i++) {
      if (I.kat.komponenten[i].r === name) out.push(I.kat.komponenten[i]);
    }
    return out;
  }

  /* ------------------------------------------------------------------
     2.7b Marken. Der Vendor schreibt sich dreifach („Anker Solix",
     „Anker SOLIX"); ohne Normalisierung zerfaellt eine Marke in mehrere
     Kacheln. Die Zuordnung kommt aus dem Metaobject-Feld vendor_werte.
     ------------------------------------------------------------------ */
  function markenIndex(I) {
    if (I._mi) return I._mi;
    var idx = {};
    (I.kat.marken || []).forEach(function (m) {
      var werte = m.vs;
      if (typeof werte === 'string') werte = [werte];
      if (!werte || !werte.length) werte = [];
      werte.concat([m.n, m.k]).forEach(function (v) {
        if (v) idx[String(v).toLowerCase().trim()] = m.k;
      });
    });
    I._mi = idx;
    return idx;
  }

  function markeVon(I, p) {
    if (!p || !p.v) return null;
    /* Ohne Metaobject gibt es keine Normalisierung. Dann ist der Vendor
       selbst der Schluessel, damit der Rueckfallweg trotzdem filtert. */
    if (!I.kat.marken || !I.kat.marken.length) return String(p.v).trim();
    return markenIndex(I)[String(p.v).toLowerCase().trim()] || null;
  }

  function markeInfo(I, key) {
    var m = I.kat.marken || [];
    for (var i = 0; i < m.length; i++) {
      if (m[i].k === key) return m[i];
    }
    return null;
  }

  /* Die gewaehlte Marke als Schluessel, oder null bei „Ist mir egal". */
  function markeAktiv(I) {
    return I.wahl.marke && I.wahl.marke !== 'egal' ? I.wahl.marke : null;
  }

  /* Waehlt aus Kandidaten. Marke schlaegt Preis, aber nur wenn es die Marke
     ueberhaupt gibt: sonst bliebe die Stueckliste leer. */
  function waehle(I, kandidaten, marke, bewerten) {
    var best = null;
    var bestWert = null;
    for (var i = 0; i < kandidaten.length; i++) {
      var k = kandidaten[i];
      var w = bewerten(k);
      if (w === null) continue;
      if (marke && markeVon(I, k) !== marke) w += 1e6;
      if (bestWert === null || w < bestWert) {
        best = k;
        bestWert = w;
      }
    }
    return best;
  }

  /* ------------------------------------------------------------------
     2.8 Zusammenstellung und Set-Findung
     ------------------------------------------------------------------ */
  function halterung(I, ort, marke, anzahl) {
    if (!ort || ort === 'ohne') return null;
    var passend = [];
    var alle = rolle(I, 'halterung');
    for (var i = 0; i < alle.length; i++) {
      /* Halterung ohne montageort kann nicht zugeordnet werden. */
      if (alle[i].o.length && alle[i].o.indexOf(ort) >= 0) passend.push(alle[i]);
    }
    if (!passend.length) return null;
    anzahl = anzahl || I.wahl.anzahl || 1;
    var best = null;
    var bestWert = null;
    for (var j = 0; j < passend.length; j++) {
      var h = passend[j];
      var traegt = h.mm && h.mm > 0 ? h.mm : 1;
      var stueck = Math.ceil(anzahl / traegt);
      var wert = stueck * h.p + (marke && markeVon(I, h) !== marke ? 1e6 : 0);
      if (bestWert === null || wert < bestWert) {
        best = { p: h, qty: stueck };
        bestWert = wert;
      }
    }
    return best;
  }

  function modul(I, marke) {
    var kandidaten = rolle(I, 'modul');
    var m = waehle(I, kandidaten, marke, function (k) {
      if (!k.wp || k.wp <= 0) return null;
      return k.p / k.wp; /* Preis je Wattpeak */
    });
    if (!m) {
      m = waehle(I, kandidaten, marke, function (k) {
        return k.p;
      });
    }
    return m;
  }

  /* Ein Geraet fuer die ganze Anlage, nicht mehrere kleine: bis 2 Module der
     800-W-Wechselrichter, ab 3 Module der grosse (KONFIGURATOR-SPEC, Frage 2).
     Deshalb zaehlt zuerst die Stueckzahl, erst danach der Preis. Zwei
     800-W-Geraete waeren zwar billiger, ergaeben aber 1600 W Einspeisung. */
  function wechselrichter(I, anzahl, marke) {
    var kandidaten = rolle(I, 'wechselrichter');
    var best = null;
    var bestWert = null;
    for (var i = 0; i < kandidaten.length; i++) {
      var w = kandidaten[i];
      /* Ohne max_module laesst sich die Stueckzahl nicht bestimmen. Das Teil
         bleibt im Katalog, wird hier aber uebersprungen statt geraten. */
      if (!w.mm || w.mm <= 0) continue;
      var stueck = Math.ceil(anzahl / w.mm);
      var wert = stueck * 1e5 + w.p + (marke && markeVon(I, w) !== marke ? 1e9 : 0);
      if (bestWert === null || wert < bestWert) {
        best = { p: w, qty: stueck };
        bestWert = wert;
      }
    }
    return best;
  }

  /* Alle Speicher-VARIANTEN einer Marke — aber nur in der GRUNDSTUFE.

     Die Kapazitaet ist eine Varianteneigenschaft: Conow Atlas 6000 AC hat
     zwanzig Varianten von 6 bis 60 kWh („1× Atlas" bis „10× Atlas"), die
     SolarVault-Reihen je sechs von 2,52 bis 15 kWh. Frueher landete jede
     dieser Stufen als eigene Kachel in Schritt 4 — bei Conow standen dort
     2 · 4 · 9 · 12 · 42 · 60 kWh, und „42 kWh" ist nichts anderes als
     siebenmal derselbe Atlas.

     Schritt 4 fragt nach dem GERAET. Die Ausbaustufen gehoeren als
     Erweiterung ins Ergebnis („Passt dazu"), nicht in die Auswahl. Deshalb
     bleibt je Handle nur die kleinste Kapazitaet stehen — das Geraet allein.

     Die Bilanz je Handle, nicht je Marke: zwei Geraete derselben Marke haben
     verschiedene Grundstufen (Solarbank 2 Pro 1,6 · Solarbank 4 Pro 5,02). */
  function speicherVarianten(I, marke) {
    var alle = rolle(I, 'speicher');
    var kleinste = {};
    var i;
    var k;
    for (i = 0; i < alle.length; i++) {
      k = alle[i];
      if (!k.kwh || k.kwh <= 0) continue;
      if (marke && markeVon(I, k) !== marke) continue;
      if (kleinste[k.h] === undefined || k.kwh < kleinste[k.h]) kleinste[k.h] = k.kwh;
    }
    var out = [];
    for (i = 0; i < alle.length; i++) {
      k = alle[i];
      if (!k.kwh || k.kwh <= 0) continue;
      if (marke && markeVon(I, k) !== marke) continue;
      if (Math.abs(k.kwh - kleinste[k.h]) > 0.001) continue;
      out.push(k);
    }
    return out;
  }

  /* Ein Eintrag je Geraet, nicht je Variante. Innerhalb eines Handles kann die
     Grundstufe mehrfach vorkommen (Atlas: „6 kWh ohne Smart Meter" und „6 kWh
     mit Smart Meter"). Lieferbar schlaegt guenstig — dieselbe Regel wie beim
     Zubehoer: ein Vorschlag, den niemand kaufen kann, ist keiner. */
  function basisGeraete(I, marke) {
    var proHandle = {};
    speicherVarianten(I, marke).forEach(function (k) {
      var bisher = proHandle[k.h];
      if (!bisher) {
        proHandle[k.h] = k;
        return;
      }
      var lieferbar = k.av === 1;
      var altLieferbar = bisher.av === 1;
      if ((lieferbar && !altLieferbar) || (lieferbar === altLieferbar && k.p < bisher.p)) {
        proHandle[k.h] = k;
      }
    });
    var out = [];
    Object.keys(proHandle).forEach(function (h) {
      out.push(proHandle[h]);
    });
    out.sort(function (a, b) {
      return a.kwh - b.kwh || a.p - b.p;
    });
    return out;
  }

  /* Das Etikett der Kachel. `kn` ist das gepflegte Metafeld konfig.kurzname;
     ohne Pflege der Produkttitel — lieber lang als geraten. Aus dem Titel
     schneiden waere Bastelei: „Conow Atlas 6000 AC Stromspeicher 6 kWh fuer
     bestehende Solaranlagen | erweiterbar bis 60 kWh, Notstrom". */
  function geraeteName(k) {
    return (k && (k.kn || k.t)) || '';
  }

  /* Die Kapazitaeten dieser Marke, aufsteigend und ohne Dubletten. Bei
     „Ist mir egal" ist das die Vereinigungsmenge aller Marken. */
  function kapazitaeten(I, marke) {
    var gesehen = {};
    var out = [];
    speicherVarianten(I, marke).forEach(function (k) {
      if (gesehen[k.kwh]) return;
      gesehen[k.kwh] = true;
      out.push(k.kwh);
    });
    out.sort(function (a, b) {
      return a - b;
    });
    return out;
  }

  /* Ueber die ganze Spanne verteilt hoechstens `max` Werte, kleinster und
     groesster immer dabei. */
  function verteile(liste, max) {
    if (liste.length <= max) return liste.slice();
    var out = [];
    for (var i = 0; i < max; i++) {
      var idx = Math.round((i * (liste.length - 1)) / (max - 1));
      if (out.indexOf(liste[idx]) < 0) out.push(liste[idx]);
    }
    return out;
  }

  /* Guenstigste Variante mit genau dieser Kapazitaet. */
  function speicherZuKwh(I, kwh, marke) {
    var best = null;
    speicherVarianten(I, marke).forEach(function (k) {
      if (Math.abs(k.kwh - kwh) > 0.001) return;
      if (!best || k.p < best.p) best = k;
    });
    return best;
  }

  /* Naechstliegendes BASISGERAET, wenn die Wunschgroesse nicht exakt existiert.
     Vorher lief das ueber `rolle(I, 'speicher')` und damit ueber alle Varianten
     — eine Wunschgroesse von 9 kWh landete so auf einer Ausbaustufe statt auf
     einem Geraet. Gebraucht wird das nur noch fuer alte, in kWh gespeicherte
     Antworten; die neue Auswahl nennt die Variante direkt. */
  function speicher(I, zielKwh, marke) {
    if (!zielKwh) return null;
    var genau = speicherZuKwh(I, zielKwh, marke);
    if (genau) return genau;
    var kandidaten = basisGeraete(I, marke);
    var best = null;
    var bestWert = null;
    kandidaten.forEach(function (k) {
      var wert = Math.abs(k.kwh - zielKwh) * 1000 + k.p / 1000;
      if (bestWert === null || wert < bestWert) {
        bestWert = wert;
        best = k;
      }
    });
    return best;
  }

  /* Hier stand `smartmeter(I, marke)` — der billigste Meter der Marke. Die
     Funktion ist mit dem Umbau ueberfluessig geworden: welcher Meter zu einem
     Speicher passt, ist eine Kompatibilitaetsfrage und keine Preisfrage, und
     sie steht als `konfig.zubehoer` am Speicher. Ein Zufallstreffer nach Marke
     haette den Jackery-Meter an einen Anker gehaengt. */

  /* Zubehoer zu genau diesem Speicher. `zub` traegt Produkt-Handles, der
     Katalog ist nach Varianten aufgebaut — je Handle also eine Zeile waehlen,
     sonst steht dasselbe Produkt mehrfach da. Lieferbar schlaegt guenstig:
     ein Vorschlag, den niemand kaufen kann, ist keiner. */
  function zubehoerZu(I, sp) {
    if (!sp || !sp.zub || !sp.zub.length) return [];
    var out = [];
    for (var i = 0; i < sp.zub.length; i++) {
      var handle = sp.zub[i];
      var best = null;
      for (var j = 0; j < I.kat.komponenten.length; j++) {
        var k = I.kat.komponenten[j];
        if (k.h !== handle) continue;
        if (!best) {
          best = k;
          continue;
        }
        var lieferbar = k.av === 1;
        var bisher = best.av === 1;
        if ((lieferbar && !bisher) || (lieferbar === bisher && k.p < best.p)) best = k;
      }
      if (best) out.push({ p: best, rolle: best.r || 'zubehoer' });
    }
    return out;
  }

  /* Das gewaehlte Geraet. Der Schluessel von Schritt 4 ist seit dem Umbau die
     VARIANTEN-ID und nicht mehr die Kapazitaet: Jackery fuehrt drei Basisgeraete
     mit identischen 2,52 kWh (SolarVault 3 Pro, Pro Max, Pro Max AC) — ueber die
     Kapazitaet waeren sie nicht auseinanderzuhalten, die Kachel „2,5 kWh" haette
     stillschweigend eines davon gewaehlt.

     Alte Zustaende und alte Links tragen noch eine Kapazitaet. Varianten-IDs
     liegen bei Shopify im Billionenbereich, Kapazitaeten unter hundert — die
     Unterscheidung ist eindeutig, und ein alter Wert landet auf dem
     naechstliegenden Basisgeraet statt im Nichts. */
  function gewaehltesGeraet(I) {
    var s = I.wahl.speicher;
    if (s === null || s === undefined || s === 'nein') return null;
    var wert = zahl(s);
    if (!wert) return null;
    if (wert < 1000) return speicher(I, wert, markeAktiv(I));
    for (var i = 0; i < I.kat.komponenten.length; i++) {
      if (I.kat.komponenten[i].id === wert) return I.kat.komponenten[i];
    }
    return null;
  }

  /* Die gewaehlte Speichergroesse in kWh. 'nein' und null ergeben 0. */
  function zielKwh(I) {
    var g = gewaehltesGeraet(I);
    return (g && g.kwh) || 0;
  }

  /* Volle Stueckliste aus den vier Antworten. */
  function stueckliste(I) {
    var w = I.wahl;
    if (!w.ort || !w.anzahl || !w.marke || w.speicher === null) return null;
    var marke = markeAktiv(I);
    var pos = [];

    var m = modul(I, marke);
    if (m) pos.push({ p: m, qty: w.anzahl, rolle: 'modul', sub: m.wp ? m.wp + ' Wp je Modul' : '' });

    /* Der Speicher wird VOR dem Wechselrichter bestimmt, weil er darueber
       entscheidet, ob ueberhaupt einer gebraucht wird. Eingereiht wird er
       weiter unten — die Reihenfolge der Anzeige bleibt, wie sie war. */
    /* Direkt das gewaehlte Geraet, nicht mehr „irgendeines mit dieser
       Kapazitaet". Die Antwort nennt die Variante — es gibt nichts mehr
       zu suchen und damit auch nichts mehr falsch zu treffen. */
    var sp = gewaehltesGeraet(I);
    var ziel = (sp && sp.kwh) || 0;

    /* `wi === true` heisst: das Geraet speist selbst ein, ein zweiter
       Wechselrichter waere doppelt gekauft (Anker, Jackery, Conow, Sunshare).
       `null` heisst „nicht gepflegt" und zaehlt bewusst wie „nein" — lieber
       ein Teil zu viel als eine Anlage, die nicht einspeisen kann. Nicht am
       Namen ablesbar: der TSUN SolarCan nimmt Module direkt auf und braucht
       trotzdem einen Wechselrichter. Ohne Speicher fuehrt kein Weg daran vorbei. */
    var wrImSpeicher = !!(sp && sp.wi === true);

    /* Traegt der eingebaute Wechselrichter weniger Module als gewaehlt, kommt
       fuer die uebrigen ein zweiter dazu (Entscheid Prince 12.08.). Ein blosser
       Hinweis waere die schlechtere Loesung: die ueberzaehligen Module haengen
       sonst am Nichts, und der Kunde merkt es erst nach dem Aufbau. Der zweite
       wird fuer den UEBERHANG bemessen, nicht fuer die ganze Anlage. */
    var ueberhang = wrImSpeicher && sp.mm > 0 && w.anzahl > sp.mm ? w.anzahl - sp.mm : 0;
    var wr = null;
    if (!wrImSpeicher) wr = wechselrichter(I, w.anzahl, marke);
    else if (ueberhang) wr = wechselrichter(I, ueberhang, marke);

    if (wr) {
      pos.push({
        p: wr.p,
        qty: wr.qty,
        rolle: 'wechselrichter',
        sub: ueberhang
          ? 'für ' + ueberhang + ' Module über die ' + sp.mm + ' am Speicher'
          : wr.p.mw
            ? 'bis ' + wr.p.mw + ' W Einspeisung'
            : ''
      });
    }

    var h = halterung(I, w.ort, marke, w.anzahl);
    if (h) {
      pos.push({
        p: h.p,
        qty: h.qty,
        rolle: 'halterung',
        sub: ORTE[w.ort] ? 'für ' + ORTE[w.ort].label : ''
      });
    }

    if (sp) {
      pos.push({
        p: sp,
        qty: 1,
        rolle: 'speicher',
        sub: kwhText(sp.kwh) + ' nutzbar' + (wrImSpeicher ? ' · Wechselrichter eingebaut' : '')
      });
    }

    /* Hier hing frueher fest an jedem Speicher ein Smart Meter. Er ist
       Zubehoer und kein Bauteil: die fertigen Sets fuehren keinen, manche
       Speicher bringen ihn mit, und in der Summe hat er den Vergleich gegen
       das Set verzerrt. Er steht jetzt ueber konfig.zubehoer UNTER der
       Liste — sichtbar, aber nicht in der Summe. Welcher Meter passt, steht als
       `konfig.zubehoer` am Speicher; die frueher dafuer benutzte Auswahl nach
       Marke und Preis ist ersatzlos entfallen. */

    if (!pos.length) return null;

    var summe = 0;
    for (var i = 0; i < pos.length; i++) summe += pos[i].p.p * pos[i].qty;

    return {
      pos: pos,
      summe: summe,
      modulWp: m && m.wp ? m.wp : 0,
      speicherKwh: sp && sp.kwh ? sp.kwh : 0,
      ohneHalterung: !h,
      /* „fehlt, obwohl gebraucht" — ein bewusst weggelassener Wechselrichter
         ist kein Mangel und darf keinen Hinweis ausloesen. Beim Ueberhang
         dagegen wird einer gebraucht: findet sich keiner, ist das eine Luecke. */
      ohneWechselrichter: !wr && (!wrImSpeicher || ueberhang > 0),
      wrImSpeicher: wrImSpeicher,
      /* Zahl der Module, die der eingebaute Wechselrichter NICHT mehr traegt,
         und seine Grenze. 0 heisst „passt" oder „nicht gepflegt". */
      modulUeberhang: ueberhang,
      speicherModule: wrImSpeicher && sp.mm > 0 ? sp.mm : 0,
      ohneSpeicher: ziel > 0 && !sp,
      zubehoer: zubehoerZu(I, sp)
    };
  }

  /* Preis und Variante eines Sets FUER DEN GEWAEHLTEN ORT. Der Set-Grundpreis
     ist der ohne Halterung; wer ihn gegen eine Konfiguration MIT Halterung
     stellt, vergleicht Aepfel mit Birnen. `halt` traegt je Ort die
     guenstigste passende Variante, gelesen aus der Varianten-Option. */
  function setFuerOrt(s, ort) {
    var h = s.halt && ort ? s.halt[ort] : null;
    if (h && h.id) return { id: h.id, p: h.p, t: h.t || '', passt: true };
    /* Kein Eintrag heisst: dieses Set gibt es fuer diesen Ort nicht.
       Das ist Sortiment, keine Datenluecke (Sunshare ohne Ziegeldach und
       Wand, mehrere Anker ohne Wand, Jackery Ultra ohne „Ohne Halterung"). */
    return { id: s.id, p: s.p, t: '', passt: false };
  }

  /* Bestes Set. Gewichtung nach KONFIGURATOR-SPEC: Speicher ja/nein wiegt am
     schwersten, dann Kapazitaet, Modulanzahl, Leistung, Montageort. Die Marke
     zaehlt darunter als letzter Ausschlag, bei Gleichstand der Preis.
     Entscheid Prince: Preis groesser null ist Pflicht, es gibt Sets mit
     0,00 EUR. */
  function bestesSet(I, ziel) {
    var best = null;
    var bestWert = null;
    for (var i = 0; i < I.kat.sets.length; i++) {
      var s = I.kat.sets[i];
      if (!s.wp || s.wp <= 0) continue; /* Sets ohne set_leistung_wp ueberspringen */
      if (!s.p || s.p <= 0) continue; /* Sets mit Preis null ueberspringen */

      var fuerOrt = setFuerOrt(s, ziel.ort);
      if (!fuerOrt.p || fuerOrt.p <= 0) continue;

      var wert = 0;
      var hatSp = !!(s.kwh && s.kwh > 0);
      var willSp = ziel.kwh > 0;
      if (hatSp !== willSp) wert += 10000;
      else if (willSp) wert += Math.abs(s.kwh - ziel.kwh) * 400;

      if (s.mod && s.mod > 0) wert += Math.abs(s.mod - ziel.anzahl) * 1000;
      else wert += 1500;

      wert += Math.abs(s.wp - ziel.wp) * 0.5;

      /* Montageort kommt jetzt aus den Varianten und ist damit belastbar:
         wer den Ort nicht abdeckt, bekommt Abzug. */
      if (!fuerOrt.passt) wert += 3000;

      if (ziel.marke && markeVon(I, s) !== ziel.marke) wert += 250;

      var kandidat = { s: s, ort: fuerOrt };
      if (bestWert === null || wert < bestWert || (wert === bestWert && best && fuerOrt.p < best.ort.p)) {
        best = kandidat;
        bestWert = wert;
      }
    }
    return best;
  }

  function rechne(I) {
    var liste = stueckliste(I);
    if (!liste) {
      I.ergebnis = null;
      I.weg = 'einzelteile';
      return null;
    }
    var w = I.wahl;
    var marke = markeAktiv(I);
    var wp = liste.modulWp * w.anzahl;

    var treffer = bestesSet(I, {
      anzahl: w.anzahl,
      wp: wp,
      kwh: liste.speicherKwh,
      ort: w.ort,
      marke: marke
    });

    var f = ORTE[w.ort] ? ORTE[w.ort].f : 0.9;
    var kwh = Math.round(((wp / 1000) * I.ertrag * f) / 10) * 10;
    var euro = Math.round((kwh * quote(liste.speicherKwh) * I.strompreis) / 10) * 10;

    /* Entscheid Prince: Gibt es kein guenstigeres Set, wird das
       naechstliegende trotzdem gezeigt — ohne Ersparnis-Auszeichnung und
       mit sachlichem Hinweis. */
    var guenstiger = !!(treffer && treffer.ort.p < liste.summe);

    I.ergebnis = {
      liste: liste,
      wp: wp,
      set: treffer ? treffer.s : null,
      setPreis: treffer ? treffer.ort.p : 0,
      setVariante: treffer ? treffer.ort.id : 0,
      setVarTitel: treffer ? treffer.ort.t : '',
      setPasst: treffer ? treffer.ort.passt : false,
      guenstiger: guenstiger,
      spart: guenstiger ? liste.summe - treffer.ort.p : 0,
      kwhJahr: kwh,
      euroJahr: euro
    };
    I.weg = guenstiger ? 'set' : 'einzelteile';
    return I.ergebnis;
  }

  /* ------------------------------------------------------------------
     2.9 DataLayer. Kein eigener Push, nur die Vorlage bedienen:
         interaktion() bei jeder Bedienung (Capture-Listener auf der Wurzel),
         step(n) bei jedem Schrittwechsel (n = 1..5, 5 ist das Ergebnis und
         loest configurator_end aus), handoff('cart') nach dem echten
         Warenkorb-Aufruf. Kein result(), keine personenbezogenen Daten.
     ------------------------------------------------------------------ */
  /* Das Vorlagen-Modul ist seitenweit ein Singleton: es misst den zuerst
     bedienten Konfigurator. Bei mehreren Instanzen auf einer Seite (Theme-
     Editor) laufen alle, gemessen wird der erste. */
  var trackBereit = false;

  function tracker() {
    return window.scConfigurator || null;
  }

  function trackStart(I) {
    var t = tracker();
    if (!t) return null;
    if (!trackBereit) {
      trackBereit = true;
      t.init({
        id: I.trackId,
        type: 'solar',
        name: 'FX Konfigurator',
        version: '1.0',
        totalSteps: SCHRITTE_GESAMT,
        currency: 'EUR',
        stepLabel: function (i) {
          return SCHRITT_LABEL[i];
        },
        getState: function () {
          return trackZustand(aktiv || instanzen[0]);
        }
      });
    }
    return t;
  }

  function trackZustand(I) {
    if (!I) return {};
    var w = I.wahl;
    var e = I.ergebnis;
    var zustand = {
      selection: {
        montageort: w.ort || null,
        module_anzahl: w.anzahl || null,
        module_watt: e && e.liste ? e.liste.modulWp : null,
        speicher_kwh: e && e.liste ? e.liste.speicherKwh : zielKwh(I),
        marke: w.marke || null
      },
      currency: 'EUR'
    };
    if (!e) {
      zustand.match = w.ort && w.anzahl && w.marke && w.speicher !== null ? 'kein_treffer' : undefined;
      return zustand;
    }
    if (I.weg === 'set' && e.set) {
      zustand.match = 'set';
      zustand.value = e.setPreis / 100;
      zustand.variantId = e.setVariante;
      zustand.items = [ga4Item(e.set, 1, e.setPreis)];
    } else {
      zustand.match = 'einzelteile';
      zustand.value = e.liste.summe / 100;
      zustand.variantId = e.liste.pos[0] ? e.liste.pos[0].p.id : undefined;
      zustand.items = [];
      for (var i = 0; i < e.liste.pos.length; i++) {
        zustand.items.push(ga4Item(e.liste.pos[i].p, e.liste.pos[i].qty));
      }
    }
    return zustand;
  }

  function ga4Item(p, qty, preis) {
    return {
      item_id: String(p.id),
      item_name: p.t,
      item_brand: p.v || undefined,
      price: (preis === undefined ? p.p : preis) / 100,
      quantity: qty
    };
  }

  function trackSchritt(I) {
    var t = tracker();
    if (t && trackBereit) t.step(I.schritt + 1);
  }

  /* ------------------------------------------------------------------
     2.10 Die vier Fragen. Jede Kachel traegt ein Bild.
     ------------------------------------------------------------------ */

  /* Schritt 1: alle Montageorte, die es im Sortiment gibt. Bild ist das
     Situationsfoto der Ort-Kollektion, sonst das Bild der Halterung. */
  function ortOptionen(I) {
    var vorhanden = {};
    var bilder = {};
    var h = rolle(I, 'halterung');
    for (var i = 0; i < h.length; i++) {
      for (var j = 0; j < h[i].o.length; j++) {
        vorhanden[h[i].o[j]] = true;
        if (!bilder[h[i].o[j]] && h[i].img) bilder[h[i].o[j]] = h[i].img;
      }
    }
    var out = [];
    for (var k = 0; k < ORT_REIHE.length; k++) {
      var id = ORT_REIHE[k];
      var kol = I.kat.orte[id];
      /* Ein Ort erscheint, wenn es eine Halterung dafuer gibt. Fehlt sie,
         koennte der Konfigurator die Anlage nicht zusammenstellen.
         Das Bild ist kein Ausschlusskriterium: dafuer gibt es das Symbol. */
      if (!vorhanden[id]) continue;
      out.push({
        id: id,
        label: ORTE[id].label,
        sub: ORTE[id].sub,
        img: (kol && kol.img) || bilder[id] || '',
        icon: ORT_ICON[id]
      });
    }
    out.push({
      id: 'ohne',
      label: 'Ohne Halterung',
      sub: 'ich habe schon eine Montagelösung',
      icon: ORT_ICON.ohne
    });
    return out;
  }

  /* Schritt 2: Modulanzahl. Bild ist das Modul, die Anzahl steht als Marke
     darauf — so arbeitet ein Bild statt einer Ziffer. */
  function anzahlOptionen(I) {
    var marke = markeAktiv(I);
    var m = modul(I, marke);
    var wp = m && m.wp ? m.wp : 0;
    var out = [];
    for (var i = 0; i < ANZAHLEN.length; i++) {
      var n = ANZAHLEN[i];
      var ab = null;
      if (m) {
        var kosten = m.p * n;
        var wr = wechselrichter(I, n, marke);
        if (wr) kosten += wr.p.p * wr.qty;
        var h = halterung(I, I.wahl.ort, marke, n);
        if (h) kosten += h.p.p * h.qty;
        ab = kosten;
      }
      out.push({
        id: n,
        tile: String(n),
        zahl: n + '×',
        img: m ? m.img : '',
        label: n + ' Module',
        sub: wp ? 'rund ' + n * wp + ' Wp' : 'Module nach Wahl',
        hint: ab ? 'ab ' + eur(ab) : ''
      });
    }
    return out;
  }

  /* Schritt 3: Marke, MIT LOGO. Quelle ist das Metaobject `marke`; gezeigt
     wird nur, was im Katalog auch vorkommt. */
  function markenOptionen(I) {
    var out = [
      {
        id: 'egal',
        tile: 'alle',
        label: 'Ist mir egal',
        sub: 'wir nehmen die beste Empfehlung',
        icon: ORT_ICON.egal
      }
    ];

    var quellen = I.kat.komponenten.concat(I.kat.sets);
    var zaehler = {};
    for (var i = 0; i < quellen.length; i++) {
      var key = markeVon(I, quellen[i]);
      if (!key) continue;
      zaehler[key] = (zaehler[key] || 0) + 1;
    }

    var marken = I.kat.marken || [];
    if (marken.length) {
      marken.forEach(function (m) {
        if (!zaehler[m.k]) return;
        var spanne = kapazitaeten(I, m.k);
        var hint = '';
        if (spanne.length > 1) hint = kwhText(spanne[0]) + ' bis ' + kwhText(spanne[spanne.length - 1]);
        else if (spanne.length === 1) hint = kwhText(spanne[0]);
        out.push({
          id: m.k,
          tile: kuerzel(m.n),
          label: m.n,
          sub: m.sub || '',
          hint: hint,
          img: m.logo || '',
          logo: true,
          farbe: m.c || ''
        });
      });
      return out;
    }

    /* Rueckfall ohne Metaobject: nach Vendor gruppieren. Dann ohne Logo,
       aber der Schritt bleibt bedienbar. */
    var vzaehler = {};
    for (var v = 0; v < quellen.length; v++) {
      var name = quellen[v].v;
      if (!name) continue;
      vzaehler[name] = (vzaehler[name] || 0) + 1;
    }
    Object.keys(vzaehler)
      .sort(function (a, b) {
        if (vzaehler[b] !== vzaehler[a]) return vzaehler[b] - vzaehler[a];
        return a < b ? -1 : 1;
      })
      .slice(0, 5)
      .forEach(function (name) {
        out.push({ id: name, tile: kuerzel(name), label: name, sub: vzaehler[name] + ' Produkte im Shop' });
      });
    return out;
  }

  function kuerzel(name) {
    var teile = String(name).split(/\s+/);
    var s = teile[0].slice(0, 2);
    if (teile.length > 1) s += teile[1].slice(0, 1);
    return s.toUpperCase();
  }

  /* Schritt 4: das GERAET, gefiltert nach Marke. Eine Kachel je Basisgeraet,
     nicht mehr je Kapazitaetsstufe — die Stufen sind Ausbaustufen desselben
     Geraets und gehoeren als Erweiterung ins Ergebnis.

     Beschriftung: Geraetename gross, Kapazitaet klein darunter. Vorher stand
     die Kapazitaet gross und der Produktname im Kleingedruckten; bei Conow
     unterschieden sich „2 kWh" und „2,6 kWh" damit nur in der Zahl, obwohl es
     zwei verschiedene Geraete sind. */
  function speicherOptionen(I) {
    var marke = markeAktiv(I);
    var out = [
      {
        id: 'nein',
        tile: 'ohne',
        label: 'Ohne Speicher',
        sub: 'günstiger Einstieg, steckerfertig',
        hint: 'ohne Aufpreis',
        icon: ORT_ICON.keinSpeicher
      }
    ];

    /* Bei „Marke egal" stehen alle Geraete an. `verteile` deckelt wie bisher
       auf KWH_KACHELN und greift ueber die ganze Kapazitaetsspanne — der
       kleinste und der groesste sind immer dabei. */
    var geraete = verteile(basisGeraete(I, marke), KWH_KACHELN);
    geraete.forEach(function (sp) {
      /* Nur der Speicher. Hier stand frueher zusaetzlich der Smart Meter drin,
         solange er zur Stueckliste gehoerte. Seit er Zubehoer ist, verspraeche
         die Kachel einen Aufpreis, den das Ergebnis nie abrechnet — beim Anker
         688 statt 599 Euro. Was die Kachel nennt, muss die Summe auch tun. */
      var name = geraeteName(sp);
      /* Nur eine ausdrueckliche 0 heisst ausverkauft. Fehlt das Feld, gilt das
         Geraet als lieferbar — ein fehlender Wert darf nicht dazu fuehren, dass
         das ganze Sortiment „bald verfuegbar" behauptet. */
      var lieferbar = sp.av !== 0;
      out.push({
        id: sp.id,
        tile: name,
        label: name,
        /* Der Variantentitel steht nur dann dabei, wenn er etwas sagt. Bei der
           Grundstufe des Atlas heisst er „6 kWh (1× Atlas 6000 AC) / Ohne Smart
           Meter" — das wiederholt die Kapazitaet und nennt eine Abwahl. */
        sub: kwhText(sp.kwh) + ' nutzbar',
        /* Ausverkauft: kein Preisversprechen, sondern der Hinweis. Der Anker
           Solarbank 4 Pro steht bewusst ohne Bestand im Sortiment — er soll zu
           sehen sein, aber nichts zusagen, was der Warenkorb nicht halten kann. */
        hint: lieferbar ? 'plus ' + eur(sp.p) : 'bald verfügbar',
        aus: !lieferbar,
        img: sp.img || ''
      });
    });
    return out;
  }

  function schrittDef(I) {
    return [
      { key: 'ort', titel: 'Wo soll die Anlage hin?', opts: ortOptionen(I) },
      { key: 'anzahl', titel: 'Wie viele Module sollen es sein?', opts: anzahlOptionen(I) },
      { key: 'marke', titel: 'Hast du eine Lieblingsmarke?', opts: markenOptionen(I) },
      /* Gefragt wird nach dem GERAET, nicht nach einer Groesse — seit Schritt 4
         Basisgeraete zeigt und keine Kapazitaetsstufen mehr. */
      { key: 'speicher', titel: 'Welcher Speicher soll es sein?', opts: speicherOptionen(I) }
    ][I.schritt];
  }

  function ansage(I, text) {
    var live = kOne('[data-fx-k-live]', I.root);
    if (live) live.textContent = text;
  }

  function anim(I, node) {
    I.anim = I.anim + 1;
    node.setAttribute('data-fx-anim', I.anim % 2 ? 'a' : 'b');
  }

  /* ------------------------------------------------------------------
     2.11 Darstellung
     ------------------------------------------------------------------ */
  function zeichne(I, fokus) {
    var stepBox = kOne('[data-fx-k-step]', I.root);
    var resBox = kOne('[data-fx-k-result]', I.root);
    var badge = kOne('[data-fx-k-badge]', I.root);
    var back = kOne('[data-fx-k-back]', I.root);
    var dots = kAll('[data-fx-k-dots] .fx-konfig__dotline', I.root);
    var ergebnis = I.schritt >= LETZTER;

    if (back) back.hidden = I.schritt === 0;
    if (badge) {
      badge.textContent = ergebnis ? 'Deine Empfehlung' : 'Schritt ' + (I.schritt + 1) + ' von ' + SCHRITTE_GESAMT;
    }

    for (var d = 0; d < dots.length; d++) {
      dots[d].className =
        'fx-konfig__dotline' +
        (d < I.schritt ? ' fx-konfig__dotline--done' : d === I.schritt ? ' fx-konfig__dotline--now' : '');
    }

    I.root.classList.toggle('fx-konfig--result', ergebnis);
    if (stepBox) stepBox.hidden = ergebnis;
    if (resBox) resBox.hidden = !ergebnis;

    if (ergebnis) zeichneErgebnis(I);
    else zeichneSchritt(I, fokus);
  }

  /* Eine Antwortkachel. Bild wenn vorhanden, sonst Symbol, sonst Kuerzel. */
  function kachel(o) {
    var tile = el('span', 'fx-konfig__opttile');
    if (o.img) {
      tile.className += o.logo ? ' fx-konfig__opttile--logo' : ' fx-konfig__opttile--bild';
      var img = document.createElement('img');
      img.className = 'fx-konfig__optimg';
      img.src = o.img;
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 160;
      img.height = 120;
      /* Faellt das Bild aus, tritt der Platzhalter an seine Stelle. Ein
         zerbrochenes Bild waere schlechter als gar keines. */
      img.addEventListener('error', function () {
        tile.className = 'fx-konfig__opttile fx-konfig__opttile--leer';
        tile.textContent = o.tile || o.label || '';
      });
      tile.appendChild(img);
      if (o.zahl) tile.appendChild(el('span', 'fx-konfig__optzahl', o.zahl));
      return tile;
    }
    if (o.icon) {
      tile.className += ' fx-konfig__opttile--icon';
      tile.innerHTML =
        '<svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
        o.icon +
        '</svg>';
      return tile;
    }
    tile.className += ' fx-konfig__opttile--leer';
    tile.textContent = o.tile || '';
    return tile;
  }

  function zeichneSchritt(I, fokus) {
    var stepBox = kOne('[data-fx-k-step]', I.root);
    var titel = kOne('[data-fx-k-title]', I.root);
    var box = kOne('[data-fx-k-opts]', I.root);
    if (!stepBox || !titel || !box) return;

    if (!I.kat.komponenten.length) {
      titel.textContent = 'Das Zusammenstellen klappt gerade nicht.';
      box.textContent = '';
      box.appendChild(el('p', 'fx-konfig__hint', 'Bitte schau direkt in unseren Sets vorbei.'));
      return;
    }

    var def = schrittDef(I);
    titel.textContent = def.titel;
    box.textContent = '';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', def.titel);

    if (!def.opts.length) {
      box.appendChild(el('p', 'fx-konfig__hint', 'Zu dieser Auswahl passt gerade nichts bei uns.'));
      return;
    }

    def.opts.forEach(function (o) {
      var btn = el('button', 'fx-konfig__opt');
      btn.type = 'button';
      if (I.wahl[def.key] === o.id) {
        btn.className += ' fx-konfig__opt--on';
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.setAttribute('aria-pressed', 'false');
      }
      if (o.farbe) btn.style.setProperty('--fx-k-marke', o.farbe);
      /* Waehlbar bleibt die Kachel auch ohne Bestand — das Geraet soll zu
         sehen und zu vergleichen sein. Nur ihr Hinweis sagt etwas anderes,
         und der Warenkorb-Knopf im Ergebnis sperrt dann. */
      if (o.aus) btn.className += ' fx-konfig__opt--aus';

      btn.appendChild(kachel(o));

      var body = el('span', 'fx-konfig__optbody');
      body.appendChild(el('span', 'fx-konfig__optlabel', o.label));
      if (o.sub) body.appendChild(el('span', 'fx-konfig__optsub', o.sub));
      if (o.hint) body.appendChild(el('span', 'fx-konfig__opthint' + (o.aus ? ' fx-konfig__opthint--aus' : ''), o.hint));
      btn.appendChild(body);

      btn.addEventListener('click', function () {
        waehleAntwort(I, def.key, o.id);
      });
      box.appendChild(btn);
    });

    anim(I, stepBox);
    ansage(I, 'Schritt ' + (I.schritt + 1) + ' von ' + SCHRITTE_GESAMT + '. ' + def.titel);
    if (fokus) titel.focus();
  }

  /* ------------------------------------------------------------------
     2.12 Der Ergebnisschirm. Er erscheint NUR hier, nie im Einstieg.
     ------------------------------------------------------------------ */
  /* ------------------------------------------------------------------
     2.12b Beschreibung des gewaehlten Speichers

     Der Text steht bewusst NICHT im Katalog-Block. Gemessen: der Katalog
     wiegt 101 KB, die zwoelf Speicher-Beschreibungen zusammen 79 KB — und
     der Katalog fuehrt eine Zeile je VARIANTE, der Atlas allein zwanzig.
     Mitgeschrieben waere das ein Drittel mehr Startseite fuer einen Text,
     den nur sieht, wer bis Schritt 5 kommt. Also erst holen, wenn jemand
     dort ankommt.

     `/products/<handle>.js` liefert `description` als fertiges HTML. Das
     ist im Konfigurator ein NEUES Muster — bisher wird nur /cart/add.js
     nachgeladen. Fehlerbehandlung von dort uebernommen, nur stiller: der
     Text ist eine Zugabe, kein Bestandteil des Kaufwegs.
     ------------------------------------------------------------------ */

  /* Ueberschriften, ab denen der Text aus dem Konfigurator hinausfuehrt.
     Alle zwoelf Beschreibungen sind gleich aufgebaut; ab hier folgen nur
     noch Wegweiser: ein roter Knopf in die Kollektion, „Passend dazu"
     (das doppelt den Passt-dazu-Kasten daneben) und Linklisten. Findet
     sich keine davon, bleibt der Text ungekuerzt — lieber zu viel als ein
     abgeschnittener Satz. */
  var DESC_STOPP = ['passend dazu', 'häufige fragen', 'haeufige fragen', 'weiterführende', 'weiterfuehrende'];

  /* Klassen, die auch VOR dem Schnitt nichts im Ergebnis zu suchen haben. */
  var DESC_RAUS = ['fh-btn', 'fh-ratgeber'];

  function descStopp(text) {
    var t = (text || '').toLowerCase();
    for (var i = 0; i < DESC_STOPP.length; i++) {
      if (t.indexOf(DESC_STOPP[i]) >= 0) return true;
    }
    return false;
  }

  /* Holt die Beschreibung, einmal je Geraet. Der Zwischenspeicher haengt an
     der Instanz: wer ueber „ändern" zwischen zwei Speichern hin- und
     herspringt, loest keinen zweiten Abruf aus. */
  function beschreibungHolen(I, handle) {
    if (!I._desc) I._desc = {};
    if (I._desc[handle] !== undefined) return Promise.resolve(I._desc[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('produkt');
        return r.json();
      })
      .then(function (d) {
        I._desc[handle] = (d && d.description) || '';
        return I._desc[handle];
      })
      .catch(function () {
        /* Nicht erneut versuchen: ein zweiter Fehlschlag haette denselben
           Grund und der Kunde saehe nur eine zweite Wartezeit. */
        I._desc[handle] = '';
        return '';
      });
  }

  /* Baut aus dem rohen Beschreibungs-HTML den Block fuers Ergebnis.

     Gelesen wird ueber DOMParser in ein TOTES Dokument, nicht ueber
     innerHTML am lebenden. Uebernommen wird nur, was uebernommen werden
     soll; ausgefuehrt werden kann dabei nichts. */
  function descAufbereiten(roh, geraeteName) {
    if (!roh) return null;
    var doc;
    try {
      doc = new DOMParser().parseFromString(roh, 'text/html');
    } catch (x) {
      return null;
    }
    var hub = doc.querySelector('.flexi-hub');
    if (!hub) return null;

    var box = el('div', 'fx-konfig__descbox');

    /* Der produkteigene <style> kommt mit. Er ist auf .flexi-hub eingegrenzt,
       greift also nicht in die Seite hinaus — und der Block sieht damit aus
       wie auf der Produktseite, ohne dieselben Regeln ein zweites Mal im
       Theme zu pflegen. */
    var stil = doc.querySelector('style');
    if (stil) {
      var s = document.createElement('style');
      s.textContent = stil.textContent;
      box.appendChild(s);
    }

    var ziel = el('div', 'flexi-hub');
    var offen = el('div', 'fx-konfig__descoffen');
    var rest = el('div', 'fx-konfig__descrest');
    var wo = offen;

    var kinder = Array.prototype.slice.call(hub.children);
    for (var i = 0; i < kinder.length; i++) {
      var k = kinder[i];
      var tag = k.tagName.toLowerCase();

      /* Ab der ersten Stopp-Ueberschrift ist Schluss. */
      if (tag === 'h2' || tag === 'h3' || tag === 'h4') {
        if (descStopp(k.textContent)) break;
        /* Nach den Kacheln beginnt der aufklappbare Teil. */
        if (wo === offen && offen.childNodes.length) wo = rest;
      }

      var wegwerfen = false;
      for (var j = 0; j < DESC_RAUS.length; j++) {
        if (k.classList && k.classList.contains(DESC_RAUS[j])) wegwerfen = true;
        if (k.querySelector && k.querySelector('.' + DESC_RAUS[j])) wegwerfen = true;
      }
      if (wegwerfen) continue;

      wo.appendChild(document.importNode(k, true));
    }

    if (!offen.childNodes.length && !rest.childNodes.length) return null;

    /* Ueberschriften eine Stufe tiefer: die Beschreibung ist hier ein
       Unterabschnitt des Ergebnisses, kein neues Kapitel. */
    [offen, rest].forEach(function (teil) {
      ['h4', 'h3', 'h2'].forEach(function (von) {
        var nach = 'h' + (parseInt(von.slice(1), 10) + 1);
        Array.prototype.slice.call(teil.querySelectorAll(von)).forEach(function (h) {
          var neu = document.createElement(nach);
          neu.className = h.className;
          while (h.firstChild) neu.appendChild(h.firstChild);
          h.parentNode.replaceChild(neu, h);
        });
      });

      /* Links bleiben klickbar, oeffnen aber ein neues Fenster — sonst waere
         die Konfiguration mit einem Klick weg. Sprungmarken wie #faq gibt es
         hier nicht, die verlieren ihren Link. */
      Array.prototype.slice.call(teil.querySelectorAll('a[href]')).forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) === '#') {
          var span = document.createElement('span');
          while (a.firstChild) span.appendChild(a.firstChild);
          a.parentNode.replaceChild(span, a);
          return;
        }
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');
      });
    });

    ziel.appendChild(offen);
    if (rest.childNodes.length) {
      var det = document.createElement('details');
      det.className = 'fx-acc fx-acc--desc';
      var sum = document.createElement('summary');
      sum.className = 'fx-acc__summary';
      sum.appendChild(el('span', 'fx-acc__label', 'Alles zum ' + (geraeteName || 'Speicher')));
      var zeichen = el('span', 'fx-acc__sign');
      zeichen.setAttribute('aria-hidden', 'true');
      zeichen.appendChild(el('span', 'fx-acc__plus'));
      zeichen.appendChild(el('span', 'fx-acc__minus'));
      sum.appendChild(zeichen);
      det.appendChild(sum);
      var koerper = el('div', 'fx-acc__body');
      koerper.appendChild(rest);
      det.appendChild(koerper);
      ziel.appendChild(det);
    }

    box.appendChild(ziel);
    return box;
  }

  /* Fuellt den Block unter der Konfiguration. Quelle ist `gewaehltesGeraet` —
     dieselbe Funktion, die Chips und Stueckliste speist. „Nur der Speicher"
     ist damit keine zusaetzliche Regel, sondern ergibt sich. */
  function zeichneBeschreibung(I) {
    var box = kOne('[data-fx-k-desc]', I.root);
    if (!box) return;
    box.textContent = '';
    box.hidden = true;

    var sp = gewaehltesGeraet(I);
    if (!sp || !sp.h) return;

    /* Merker gegen Ueberholen: wer schnell zwischen Speichern wechselt,
       bekaeme sonst die Antwort des vorigen Abrufs eingehaengt. */
    var lauf = (I._descLauf || 0) + 1;
    I._descLauf = lauf;

    beschreibungHolen(I, sp.h).then(function (roh) {
      if (I._descLauf !== lauf) return;
      var inhalt = descAufbereiten(roh, geraeteName(sp));
      /* Kein Text, kein Kasten — und ausdruecklich keine Fehlermeldung.
         Der Block ist eine Zugabe; ein rotes Kaestchen dafuer behauptete ein
         Problem, das keines ist. Der Kaufweg bleibt unberuehrt. */
      if (!inhalt || I._descLauf !== lauf) return;
      box.appendChild(inhalt);
      box.hidden = false;
    });
  }

  function zeichneErgebnis(I) {
    var resBox = kOne('[data-fx-k-result]', I.root);
    var chips = kOne('[data-fx-k-chips]', I.root);
    var save = kOne('[data-fx-k-savings]', I.root);
    var cards = kOne('[data-fx-k-cards]', I.root);
    var err = kOne('[data-fx-k-err]', I.root);
    var lader = kOne('[data-fx-k-lader]', I.root);
    if (!resBox || !cards) return;

    /* Ladeanzeige erst ab 300 ms. Die Set-Suche laeuft im Regelfall in
       wenigen Millisekunden durch; dann darf nichts aufblitzen. */
    var wecker = 0;
    if (lader) {
      lader.hidden = true;
      wecker = window.setTimeout(function () {
        lader.hidden = false;
      }, 300);
    }
    var e = rechne(I);
    if (wecker) window.clearTimeout(wecker);
    if (lader) lader.hidden = true;

    if (chips) {
      chips.textContent = '';
      chipsBauen(I).forEach(function (c) {
        var b = el('button', 'fx-konfig__chip');
        b.type = 'button';
        b.appendChild(el('span', null, c.text));
        b.appendChild(el('span', 'fx-konfig__chipact', 'ändern'));
        b.addEventListener('click', function () {
          I.schritt = c.schritt;
          zeichne(I, true);
        });
        chips.appendChild(b);
      });
    }

    cards.textContent = '';
    /* Auch auf dem Weg „kein Ergebnis" leeren — sonst bliebe die
       Beschreibung des vorigen Speichers unter einer leeren Konfiguration
       stehen. */
    var descBox = kOne('[data-fx-k-desc]', I.root);
    if (descBox) {
      descBox.textContent = '';
      descBox.hidden = true;
    }
    if (err) {
      err.hidden = true;
      err.textContent = '';
    }

    if (!e) {
      if (save) save.hidden = true;
      cards.className = 'fx-konfig__cards';
      cards.appendChild(
        el(
          'p',
          'fx-konfig__hint',
          'Für diese Kombination finden wir gerade keine passenden Bauteile. Ändere eine Angabe oder schau dir unsere fertigen Sets an.'
        )
      );
      anim(I, resBox);
      ansage(I, 'Kein Ergebnis. Bitte eine Angabe ändern.');
      return;
    }

    if (save) {
      if (I.zeigeErsparnis) {
        save.hidden = false;
        save.textContent = '';
        save.appendChild(kasten('rund ' + e.euroJahr.toLocaleString('de-DE') + ' €', 'geschätzte Stromersparnis pro Jahr'));
        save.appendChild(kasten('rund ' + e.kwhJahr.toLocaleString('de-DE') + ' kWh', 'Sonnenstrom pro Jahr'));
        save.appendChild(kasten(e.wp.toLocaleString('de-DE') + ' Wp', 'Modulleistung deiner Anlage'));
      } else {
        save.hidden = true;
      }
    }

    cards.className = 'fx-konfig__cards' + (e.set ? ' fx-konfig__cards--two' : '');
    cards.appendChild(karteEigen(I, e));
    if (e.set) cards.appendChild(karteSet(I, e));

    /* Laeuft nebenher und haelt nichts auf: das Ergebnis steht sofort, die
       Beschreibung kommt nach. */
    zeichneBeschreibung(I);

    anim(I, resBox);
    ansage(
      I,
      'Deine Empfehlung steht. Eigene Zusammenstellung ' +
        eur(e.liste.summe) +
        (e.set
          ? e.guenstiger
            ? '. Unser Set ' + eur(e.setPreis) + ', du sparst ' + eur(e.spart) + '.'
            : '. Unser nächstliegendes Set ' + eur(e.setPreis) + ', deine Zusammenstellung ist günstiger.'
          : '.')
    );
  }

  function kasten(zahlText, label) {
    var box = el('div', 'fx-konfig__savebox');
    box.appendChild(el('span', 'fx-konfig__savenum', zahlText));
    box.appendChild(el('span', 'fx-konfig__savelbl', label));
    return box;
  }

  function chipsBauen(I) {
    var w = I.wahl;
    var ortLabel = w.ort === 'ohne' ? 'Ohne Halterung' : ORTE[w.ort] ? ORTE[w.ort].label : String(w.ort);
    var m = markeInfo(I, w.marke);
    /* Der Chip nennt das Geraet, nicht die Kapazitaet: „2,5 kWh Speicher"
       waere bei Jackery dreideutig (SolarVault 3 Pro, Pro Max, Pro Max AC
       haben alle 2,52 kWh). Ohne Kurzname bleibt die Kapazitaet als Rueckfall. */
    var spGeraet = gewaehltesGeraet(I);
    var spLabel = 'Ohne Speicher';
    if (spGeraet) spLabel = geraeteName(spGeraet) || kwhText(spGeraet.kwh) + ' Speicher';
    return [
      { text: ortLabel, schritt: 0 },
      { text: w.anzahl + ' Module', schritt: 1 },
      { text: w.marke === 'egal' ? 'Marke egal' : m ? m.n : String(w.marke), schritt: 2 },
      { text: spLabel, schritt: 3 }
    ];
  }

  /* Ein Satz, was das Teil tut — kein Datenblatt. Was nicht erklaerbar ist,
     bekommt keine Zeile statt einer erfundenen. */
  function zubehoerNutzen(z) {
    if (z.rolle === 'smartmeter') return 'misst den Hausverbrauch, damit der Speicher richtig regelt';
    if (z.rolle === 'erweiterung' || z.rolle === 'speicher') {
      return z.p.kwh ? 'erweitert den Speicher um ' + kwhText(z.p.kwh) : 'erweitert den Speicher';
    }
    return '';
  }

  /* „Passt dazu" — Zubehoer zum gewaehlten Speicher, UNTER der Stueckliste und
     AUSSERHALB der Summe. Genau daran ist der Smart Meter frueher gescheitert:
     er stand in der Summe und hat den Vergleich gegen das fertige Set verzerrt,
     obwohl das Set ihn gar nicht enthaelt.

     Die Zeilen benutzen bewusst die Klassen der Stueckliste — gleiche Optik,
     kein neues Zeilen-CSS. Neu ist nur der kleine Knopf. */
  function zoneZubehoer(I, e) {
    var teile = (e.liste && e.liste.zubehoer) || [];
    if (!teile.length) return null;

    var zone = el('div', 'fx-konfig__zub');

    /* Eigene Karte mit Kopfleiste statt gestrichelter Trennlinie. Der Block
       ging vorher unter — er steht unter der Summe und sah aus wie ein
       Nachklapp. Die Anzahl steht dabei, weil sie den Blick lohnt: „drei
       Vorschlaege" ist ein Grund hinzusehen, „Passt dazu" allein nicht. */
    var kopf = el('div', 'fx-konfig__zubhead');
    kopf.appendChild(el('span', 'fx-konfig__zubtitle', 'Passt dazu'));
    kopf.appendChild(
      el('span', 'fx-konfig__zubcount', teile.length === 1 ? '1 Vorschlag' : teile.length + ' Vorschläge')
    );
    zone.appendChild(kopf);

    /* Eigene Zeilenklasse, obwohl die Optik dieselbe ist: sonst faende jeder
       Selektor auf `.fx-konfig__row` die Zubehoerzeilen mit — der Pruefstand
       zaehlt darueber die Positionen der Stueckliste. Das CSS teilen sich
       beide ueber einen Gruppenselektor, doppelt gepflegt wird nichts. */
    var ul = el('ul', 'fx-konfig__zublist');
    teile.forEach(function (z) {
      var li = document.createElement('li');
      var zeile = el('div', 'fx-konfig__zubrow');

      var thumb = el('span', 'fx-konfig__rowthumb');
      if (z.p.img) {
        var bild = document.createElement('img');
        bild.src = z.p.img;
        bild.alt = '';
        bild.loading = 'lazy';
        bild.decoding = 'async';
        bild.width = 44;
        bild.height = 44;
        bild.addEventListener('error', function () {
          if (bild.parentNode) bild.parentNode.removeChild(bild);
        });
        thumb.appendChild(bild);
      }
      zeile.appendChild(thumb);

      var body = el('span', 'fx-konfig__rowbody');
      body.appendChild(el('span', 'fx-konfig__rowname', z.p.t + (z.p.vt ? ' · ' + z.p.vt : '')));
      var sub = [zubehoerNutzen(z), eur(z.p.p)].filter(Boolean).join(' · ');
      body.appendChild(el('span', 'fx-konfig__rowsub', sub));
      zeile.appendChild(body);

      var add = el('button', 'fx-konfig__zubadd');
      add.type = 'button';
      add.textContent = 'Dazulegen';
      add.setAttribute('aria-label', z.p.t + ' in den Warenkorb');
      add.addEventListener('click', function () {
        inWarenkorb(I, 'zubehoer', add, z.p);
      });
      zeile.appendChild(add);

      li.appendChild(zeile);
      ul.appendChild(li);
    });

    zone.appendChild(ul);
    return zone;
  }

  function karteEigen(I, e) {
    var card = el('div', 'fx-konfig__col fx-konfig__col--eigen');

    var top = el('div', 'fx-konfig__coltop');
    top.appendChild(el('span', 'fx-konfig__coltitle', 'Deine Anlage'));
    top.appendChild(el('span', 'fx-konfig__colnote', e.liste.pos.length + (e.liste.pos.length === 1 ? ' Teil' : ' Teile')));
    card.appendChild(top);

    var liste = el('ul', 'fx-konfig__bom');
    liste.setAttribute('role', 'list');
    e.liste.pos.forEach(function (r) {
      var li = document.createElement('li');
      /* Die ganze Zeile ist der Link: ein Tastziel ueber die volle Breite und
         mindestens 44 Pixel hoch, statt eines schmalen Textlinks. */
      var zeile = document.createElement('a');
      zeile.className = 'fx-konfig__row';
      zeile.href = '/products/' + r.p.h;

      /* Auch die Stueckliste arbeitet mit Bildern statt mit Text allein. Die
         Menge liegt als kleine Marke auf dem Bild, damit die Zeile auf 320
         Pixel nicht aus zwei Kaesten vor dem Namen besteht. */
      var thumb = el('span', 'fx-konfig__rowthumb');
      if (r.p.img) {
        var bild = document.createElement('img');
        bild.src = r.p.img;
        bild.alt = '';
        bild.loading = 'lazy';
        bild.decoding = 'async';
        bild.width = 44;
        bild.height = 44;
        bild.addEventListener('error', function () {
          if (bild.parentNode) bild.parentNode.removeChild(bild);
        });
        thumb.appendChild(bild);
      }
      thumb.appendChild(el('span', 'fx-konfig__rowqty', r.qty + '×'));
      zeile.appendChild(thumb);

      var body = el('span', 'fx-konfig__rowbody');
      var name = r.p.t + (r.p.vt ? ' · ' + r.p.vt : '');
      body.appendChild(el('span', 'fx-konfig__rowname', name));
      var sub = [r.sub, eur(r.p.p) + ' je Stück'].filter(Boolean).join(' · ');
      body.appendChild(el('span', 'fx-konfig__rowsub', sub));
      zeile.appendChild(body);

      zeile.appendChild(el('span', 'fx-konfig__rowsum', eur(r.p.p * r.qty)));
      li.appendChild(zeile);
      liste.appendChild(li);
    });
    card.appendChild(liste);

    var sum = el('div', 'fx-konfig__sum');
    sum.appendChild(el('span', 'fx-konfig__sumlbl', 'Summe der Bauteile'));
    sum.appendChild(el('span', 'fx-konfig__sumval', eur(e.liste.summe)));
    card.appendChild(sum);

    /* Ist das Set guenstiger, ist es der Hauptknopf und dieser hier die
       sachliche Alternative. Sonst genau umgekehrt. */
    var haupt = !e.guenstiger;
    /* Steht ein Teil ohne Bestand in der Liste, fuehrt der Knopf ins Leere:
       Shopify lehnt die Zeile ab und der Kunde sieht eine Fehlermeldung statt
       eines Warenkorbs. Dann lieber gar nicht erst anbieten und sagen, warum. */
    var nichtLieferbar = e.liste.pos.filter(function (r) {
      return r.p && r.p.av === 0;
    });
    /* Spiegelbildlich zur Kachel: nur eine ausdrueckliche 0 sperrt. */
    var btn = el('button', 'fx-konfig__buy' + (haupt ? '' : ' fx-konfig__buy--ghost'));
    btn.type = 'button';
    btn.textContent = 'Alle Teile in den Warenkorb';
    if (nichtLieferbar.length) {
      btn.disabled = true;
      btn.textContent = 'Noch nicht bestellbar';
    } else {
      btn.addEventListener('click', function () {
        inWarenkorb(I, 'einzelteile', btn);
      });
    }
    card.appendChild(btn);

    var hinweise = [];
    if (nichtLieferbar.length) {
      hinweise.push(
        nichtLieferbar
          .map(function (r) {
            return r.p.kn || r.p.t;
          })
          .join(' und ') + ' ist noch nicht lieferbar. Die Anlage lässt sich deshalb noch nicht bestellen.'
      );
    }
    if (e.liste.ohneHalterung && I.wahl.ort !== 'ohne') hinweise.push('Für diesen Ort führen wir gerade keine Halterung.');
    if (e.liste.ohneWechselrichter) hinweise.push('Den passenden Wechselrichter wählst du im Shop dazu.');
    if (e.liste.modulUeberhang) {
      hinweise.push(
        'Der Speicher nimmt ' +
          e.liste.speicherModule +
          ' Module auf. Für die übrigen ' +
          e.liste.modulUeberhang +
          ' ist ein Wechselrichter dabei.'
      );
    }
    if (e.liste.ohneSpeicher) hinweise.push('In dieser Größe haben wir gerade keinen Speicher da.');
    /* Hier stand „Jedes Bauteil kommt als eigene Position in den Warenkorb."
       Der Satz beschrieb die Technik hinter dem Knopf und hat verunsichert
       statt beruhigt — ersatzlos gestrichen (Entscheid Prince 12.08.). */
    if (hinweise.length) card.appendChild(el('p', 'fx-konfig__hint', hinweise.join(' ')));

    var zone = zoneZubehoer(I, e);
    if (zone) card.appendChild(zone);

    return card;
  }

  function karteSet(I, e) {
    var s = e.set;
    var card = el('div', 'fx-konfig__col fx-konfig__col--set' + (e.guenstiger ? ' fx-konfig__col--top' : ''));

    var top = el('div', 'fx-konfig__coltop');
    top.appendChild(el('span', 'fx-konfig__coltitle', e.guenstiger ? 'Unser Set, unsere Empfehlung' : 'Unser nächstliegendes Set'));
    if (e.guenstiger) {
      var prozent = Math.round((e.spart / e.liste.summe) * 100);
      top.appendChild(el('span', 'fx-konfig__flag', 'spare ' + eur(e.spart) + ' (' + prozent + ' %)'));
    }
    card.appendChild(top);

    if (s.img) {
      var media = document.createElement('a');
      media.className = 'fx-konfig__setmedia';
      media.href = s.u || '/products/' + s.h;
      var img = document.createElement('img');
      img.className = 'fx-konfig__setimg';
      img.src = s.img;
      img.alt = s.t;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 320;
      img.height = 240;
      media.appendChild(img);
      card.appendChild(media);
    }

    var name = document.createElement('a');
    name.className = 'fx-konfig__setname';
    name.href = s.u || '/products/' + s.h;
    name.textContent = s.t;
    card.appendChild(name);

    var preis = el('div', 'fx-konfig__pricerow');
    preis.appendChild(el('span', 'fx-konfig__sumval', eur(e.setPreis)));
    if (e.guenstiger) {
      preis.appendChild(el('span', 'fx-konfig__compare', eur(e.liste.summe)));
      preis.appendChild(el('span', 'fx-konfig__save', 'du sparst ' + eur(e.spart)));
    }
    card.appendChild(preis);

    var btn = el('button', 'fx-konfig__buy' + (e.guenstiger ? '' : ' fx-konfig__buy--ghost'));
    btn.type = 'button';
    btn.textContent = 'Set in den Warenkorb';
    btn.addEventListener('click', function () {
      inWarenkorb(I, 'set', btn);
    });
    card.appendChild(btn);

    var teile = [];
    if (s.mod) teile.push(s.mod + ' Module');
    if (s.wp) teile.push(s.wp + ' Wp');
    if (s.kwh) teile.push(kwhText(s.kwh) + ' Speicher');
    if (e.setVarTitel) teile.push(e.setVarTitel);
    card.appendChild(el('p', 'fx-konfig__hint', teile.join(' · ') || 'Komplettset aus dem Shop'));

    var noten = [];
    if (!e.guenstiger) noten.push('Deine eigene Zusammenstellung ist hier günstiger.');
    if (!e.setPasst) {
      /* Das Set deckt den gewaehlten Ort nicht ab. Beide Richtungen kommen
         vor: Sunshare ohne Ziegeldach und Wand, die Jackery-Ultra-Sets ohne
         „Ohne Halterung". Gezeigt wird das Set trotzdem, benannt wird es auch. */
      if (I.wahl.ort === 'ohne') noten.push('Dieses Set gibt es nur zusammen mit einer Halterung.');
      else noten.push('Dieses Set gibt es nicht mit Halterung für ' + (ORTE[I.wahl.ort] ? ORTE[I.wahl.ort].label : I.wahl.ort) + '.');
    }
    if (noten.length) card.appendChild(el('p', 'fx-konfig__note-in', noten.join(' ')));

    return card;
  }

  /* ------------------------------------------------------------------
     2.13 Bedienung
     ------------------------------------------------------------------ */
  function waehleAntwort(I, key, wert) {
    I.wahl[key] = wert;

    /* Die Marke bestimmt, welche Kapazitaeten es gibt. Passt die zuvor
       gewaehlte Groesse nicht mehr zur neuen Marke, wird sie verworfen und
       Schritt 4 erneut gestellt — statt still etwas anderes zu liefern. */
    if (key === 'marke' && I.wahl.speicher !== null) {
      var moeglich = speicherOptionen(I).map(function (o) {
        return o.id;
      });
      if (moeglich.indexOf(I.wahl.speicher) < 0) I.wahl.speicher = null;
    }

    var w = I.wahl;
    /* Steht schon alles, fuehrt jede Aenderung direkt zurueck zum Ergebnis.
       Genau das erwartet der Kunde, wenn er ueber „ändern" hergekommen ist. */
    var vollstaendig = w.ort && w.anzahl && w.marke && w.speicher !== null;
    I.schritt = vollstaendig ? LETZTER : Math.min(I.schritt + 1, LETZTER);
    zeichne(I, true);
    trackSchritt(I);
  }

  function zurueck(I) {
    if (I.schritt <= 0) return;
    I.schritt = I.schritt - 1;
    zeichne(I, true);
  }

  function neuStarten(I) {
    I.schritt = 0;
    I.wahl = { ort: null, anzahl: null, marke: null, speicher: null };
    I.ergebnis = null;
    I.weg = 'einzelteile';
    zeichne(I, true);
  }

  /* Alle Positionen in EINEM Aufruf, nicht in der Schleife.
     `stueck` ist der Weg fuer die Zubehoerzone: genau ein Artikel, sonst
     dieselbe Strecke — ein zweiter Fetch-Pfad waere eine zweite Fehlerquelle. */
  function inWarenkorb(I, weg, btn, stueck) {
    var e = I.ergebnis;
    if (!e) return;
    I.weg = weg;

    var items = [];
    if (weg === 'zubehoer') {
      if (!stueck) return;
      items.push({ id: stueck.id, quantity: 1 });
    } else if (weg === 'set' && e.set) {
      /* Die Variante mit der richtigen Halterung, nicht die Grundvariante. */
      items.push({ id: e.setVariante || e.set.id, quantity: 1 });
    } else {
      for (var i = 0; i < e.liste.pos.length; i++) {
        items.push({ id: e.liste.pos[i].p.id, quantity: e.liste.pos[i].qty });
      }
    }
    if (!items.length) return;

    var err = kOne('[data-fx-k-err]', I.root);
    if (err) err.hidden = true;
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }

    /* Der Warenkorb-Drawer des Themes statt eines Seitenwechsels: wer hier
       etwas anlegt, soll auf der Konfiguratorseite bleiben — und das gilt
       fuer alle drei Wege gleich, Einzelteile, Set und „Dazulegen".

       Das Theme bringt <cart-drawer> mit `renderContents(antwort)` mit: die
       Funktion tauscht die beiden Abschnitte aus UND oeffnet den Drawer
       selbst. Voraussetzung ist, dass der Aufruf `sections` und
       `sections_url` mitschickt — genau so macht es auch das
       Produktformular des Themes (main.js, ProductForm). */
    var drawer = document.querySelector('cart-drawer');
    var abschnitte =
      drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map(function (a) {
            return a.id;
          })
        : null;

    var rumpf = { items: items };
    if (abschnitte && abschnitte.length) {
      rumpf.sections = abschnitte;
      rumpf.sections_url = window.location.pathname;
    }

    /* Integration in den Drawer-Refresh des Themes (20.0.6, 11.09.2026): main.js
       refreshIfStale() gleicht den Drawer beim Oeffnen/Sichtbarwerden mit /cart.js ab und
       verwirft seine Antwort nur, wenn seit seinem Start ein Theme-Write begonnen hat
       (window.scCartEpoch) oder gerade einer laeuft (Marker cart__items--disabled auf der
       Korbliste). Dieser Add ist kein Theme-Formular — also beides selbst setzen, sonst
       konnte eine verspaetete Refresh-Antwort den frisch gerenderten Korb ueberschreiben
       (gemessen 11.09., Messung M5). Der Marker verschwindet mit dem Rerender, im
       Fehlerfall wird er unten wieder entfernt. */
    window.scCartEpoch = (window.scCartEpoch || 0) + 1;
    var korbListe = drawer ? drawer.querySelector('cart-drawer-items') : null;
    if (korbListe) korbListe.classList.add('cart__items--disabled');

    fetch(I.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(rumpf)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(function (antwort) {
        var t = tracker();
        if (t && trackBereit) t.handoff('cart');

        /* Der Rest des Themes haengt am selben Ereignis wie beim
           Produktformular — sonst bliebe etwa die Zahl am Warenkorbsymbol
           auf Seiten stehen, die eigene Zaehler fuehren. */
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fx-konfigurator' });
          }
        } catch (x) {
          /* Das Theme kann anders gebaut sein. Kein Grund, den Warenkorb
             scheitern zu lassen. */
        }

        if (drawer && typeof drawer.renderContents === 'function' && antwort && antwort.sections) {
          /* Der Knopf wird wieder bedienbar — die Seite bleibt ja stehen. */
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }
          /* `is-empty` am Drawer-Element abnehmen, BEVOR gerendert wird.
             Das Theme macht das an derselben Stelle (main.js, ProductForm im
             `finally`) — ohne diesen Schritt sucht `open()` beim ersten
             Anlegen in einen leeren Warenkorb noch `.drawer__inner-empty`,
             das renderContents gerade ersetzt hat, und `trapFocus` faellt
             auf null. Gemessen: „Cannot read properties of null (reading
             'querySelectorAll')" in getFocusableElements. */
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn || document.activeElement);
          drawer.renderContents(antwort);
          var korbListeNeu = drawer.querySelector('cart-drawer-items');
          if (korbListeNeu) korbListeNeu.classList.remove('cart__items--disabled');
          ansage(I, 'Im Warenkorb. Der Warenkorb ist geöffnet.');
          return;
        }

        /* Kein Drawer im Theme oder keine Abschnitte in der Antwort: dann der
           alte Weg. Lieber ein Seitenwechsel als ein Klick, der scheinbar
           nichts bewirkt. */
        window.location.href = I.cartUrl;
      })
      .catch(function () {
        if (korbListe) korbListe.classList.remove('cart__items--disabled');
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }
        if (err) {
          err.hidden = false;
          err.textContent = 'Das hat gerade nicht geklappt. Bitte versuche es noch einmal.';
        }
        ansage(I, 'Der Warenkorb konnte nicht gefüllt werden.');
      });
  }

  /* ------------------------------------------------------------------
     2.14 Bindung, je Wurzel genau einmal
     ------------------------------------------------------------------ */
  function binde(root) {
    if (root.hasAttribute('data-fx-k-bound')) return;
    root.setAttribute('data-fx-k-bound', '');
    var I = instanz(root);

    kAll('[data-fx-k-back]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        zurueck(I);
      });
    });

    kAll('[data-fx-k-restart]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        neuStarten(I);
      });
    });

    /* Ein einziger Listener in der Capture-Phase meldet jede Bedienung an das
       Tracking-Modul. Er laeuft garantiert vor den Schritt-Handlern. */
    ['click', 'input', 'change'].forEach(function (typ) {
      root.addEventListener(
        typ,
        function () {
          aktiv = I;
          var t = trackStart(I);
          if (t) t.interaktion();
        },
        true
      );
    });

    zeichne(I, false);
  }

  var globalBereit = false;

  function registriereGlobal() {
    if (globalBereit) return;
    globalBereit = true;

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', function () {
      instanzen = instanzen.filter(function (I) {
        return document.contains(I.root);
      });
      if (aktiv && !document.contains(aktiv.root)) aktiv = null;
    });
  }

  function init() {
    var wurzeln = document.querySelectorAll('[data-fx-konfig]');
    for (var i = 0; i < wurzeln.length; i++) binde(wurzeln[i]);
    registriereGlobal();
  }

  window[NS] = {
    init: init,
    instances: function () {
      return instanzen.slice();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ==========================================================================
   ABSCHNITT 2 — KONFIGURATOR                                        E N D E
   ========================================================================== */
